import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SearchCountryField, CountryISO, PhoneNumberFormat, NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { AuthService } from '../../Service/app-service';
import { SearchPipe } from '../../search-pipe.pipe';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { Router, RouterModule } from '@angular/router';
import * as XLSX from 'xlsx';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NgSelectModule } from '@ng-select/ng-select';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';
import { SharedService } from '../../Service/shared.service';


@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    NgSelectModule,
    DragDropModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    NgxIntlTelInputModule,
    SearchPipe,
    NgxSpinnerModule,
    NgMultiSelectDropDownModule,
    RouterModule
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {
  @ViewChild('searchInput') searchInput!: ElementRef;
  globalPlaylistsArray:any = [];
  publisherSongs:any;
  manageContent:any;
  formMode='';
  formTitle = '';
  showPopup = false;
  playlistForm: any;
  imageError: string | null = null;
  songDetailsArray: any = [];
  callertuneDetails: any = [];
  globalPlaylists:any = [];
  genres: any = [];
  openConetnt = false;
  itemsArray: any[] = [];
  viewAllListedArray: any = [];
  artistDetails: any = [];
  PropName: any;
  containersNmae: any;
  ViewAllText: any;
  viewContent: boolean = false;
  filteredHiddenSongsArray: any = [];
  TewxtName: any;
  addContent: boolean = false;
  selectedCaroselsId: any;
  storedName: any;
  selectedImage: string | ArrayBuffer | null = null;
  selectedenereImage: string | ArrayBuffer | null = null;
  showCurrentPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;
  selectedCountries = 'Eligible';
  showFilteredOptions: boolean = false;
  selectAll: boolean = false;
  selectedTab: string = 'All';
  musicFileUrl: string | null = null;
  crbtFileUrl: string | null = null;
  ivrFileUrl: string | null = null;
  isPasswordVisible: boolean = false;
  dropdownSettings = {};
  countrySettings = {};
  tagsSettings = {};
  ListArray: any = [];
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  tagsArray: any[] = [];
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  toBeDeletedId: any;
  toBeDeletedText: any;
  toBeEditedTagId: any;
  deploymentsArray: any;
  genreArray: any;
  artistArray: any;
  role: boolean = false;
  user: boolean = false;
  userArray: any[] = [];
  roleArray: any = [];
  publisherArray: any[] = [];
  muiscId: any;
  paginatedData: any[] = [];
  viewAllName: any;
  languageArray: any[] = [];
  musicArray: any[] = [];
  countryArray: any[] = [];
  selectedCountryoption: string = 'Eligible';
  previewImageUrl: string | null = null;
  preViewImage: File | null = null;
  filteredMusicArray: any[] = [];
  CarosulesConetnt: any = {};
  filteredTgasArray: any[] = [];
  filteredPublisherArray: any[] = [];
  filteredCountryArray: any[] = [];
  filteredViewAllArray: any[] = [];
  viewAllArray: any = [];
  filteredDeployementArray: any[] = [];
  addGloboloContent:any;
  filteredListArray: any[] = [];
  listedListedArray: any[] = [];
  filteredArtistArray: any[] = [];
  filteredGeneresArray: any[] = [];
  filteredUserArray: any[] = [];
  filteredRoleArray: any[] = [];
  selectedCrbtFile: File | null = null; statusChangeText: any;
  statusChangeMuiscDetails: any;
  selectedTax: any;
  userName: any;
  roles: any;
  editPlaylistId:any;
  tabMusicArray: any[] = [];
  genreListedArray: any[] = [];
  tagListedArray: any[] = [];
  userListedArray: any[] = [];
  roleListedArray: any[] = [];
  artistListedArray: any[] = [];
  publisherListedArray: any[] = [];
  deploymentListedArray: any[] = [];
  selectedIvrFile: File | null = null;;
  selectedMuiscFile: File | null = null;;
  changePreferredCountries() { this.preferredCountries = [CountryISO.India, CountryISO.Canada]; }
  isOn: boolean = false;
  music: boolean = false;
  tagsData: any = [];
  notificationData:any;
  manageNotification:boolean = false;
  openConfirmChnagePopup: boolean = false;
  conentApproval: boolean = false;
  countries: { code: string, name: string }[] = [
    { code: 'AF', name: 'Afghanistan' },
    { code: 'AL', name: 'Albania' },
    { code: 'DZ', name: 'Algeria' },
    { code: 'AS', name: 'American Samoa' },
    { code: 'AD', name: 'Andorra' },
    { code: 'AO', name: 'Angola' },
    { code: 'AI', name: 'Anguilla' },
    { code: 'AQ', name: 'Antarctica' },
    { code: 'AG', name: 'Antigua and Barbuda' },
    { code: 'AR', name: 'Argentina' },
    { code: 'AM', name: 'Armenia' },
    { code: 'AW', name: 'Aruba' },
    { code: 'AU', name: 'Australia' },
    { code: 'AT', name: 'Austria' },
    { code: 'AZ', name: 'Azerbaijan' },
    { code: 'BS', name: 'Bahamas' },
    { code: 'BH', name: 'Bahrain' },
    { code: 'BD', name: 'Bangladesh' },
    { code: 'BB', name: 'Barbados' },
    { code: 'BY', name: 'Belarus' },
    { code: 'BE', name: 'Belgium' },
    { code: 'BZ', name: 'Belize' },
    { code: 'BJ', name: 'Benin' },
    { code: 'BM', name: 'Bermuda' },
    { code: 'BT', name: 'Bhutan' },
    { code: 'BO', name: 'Bolivia' },
    { code: 'BQ', name: 'Bonaire, Sint Eustatius and Saba' },
    { code: 'BA', name: 'Bosnia and Herzegovina' },
    { code: 'BW', name: 'Botswana' },
    { code: 'BV', name: 'Bouvet Island' },
    { code: 'BR', name: 'Brazil' },
    { code: 'IO', name: 'British Indian Ocean Territory' },
    { code: 'BN', name: 'Brunei Darussalam' },
    { code: 'BG', name: 'Bulgaria' },
    { code: 'BF', name: 'Burkina Faso' },
    { code: 'BI', name: 'Burundi' },
    { code: 'CV', name: 'Cabo Verde' },
    { code: 'KH', name: 'Cambodia' },
    { code: 'CM', name: 'Cameroon' },
    { code: 'CA', name: 'Canada' },
    { code: 'KY', name: 'Cayman Islands' },
    { code: 'CF', name: 'Central African Republic' },
    { code: 'TD', name: 'Chad' },
    { code: 'CL', name: 'Chile' },
    { code: 'CN', name: 'China' },
    { code: 'CX', name: 'Christmas Island' },
    { code: 'CC', name: 'Cocos (Keeling) Islands' },
    { code: 'CO', name: 'Colombia' },
    { code: 'KM', name: 'Comoros' },
    { code: 'CG', name: 'Congo' },
    { code: 'CD', name: 'Congo, Democratic Republic of the' },
    { code: 'CK', name: 'Cook Islands' },
    { code: 'CR', name: 'Costa Rica' },
    { code: 'HR', name: 'Croatia' },
    { code: 'CU', name: 'Cuba' },
    { code: 'CW', name: 'Curaçao' },
    { code: 'CY', name: 'Cyprus' },
    { code: 'CZ', name: 'Czech Republic' },
    { code: 'DK', name: 'Denmark' },
    { code: 'DJ', name: 'Djibouti' },
    { code: 'DM', name: 'Dominica' },
    { code: 'DO', name: 'Dominican Republic' },
    { code: 'EC', name: 'Ecuador' },
    { code: 'EG', name: 'Egypt' },
    { code: 'SV', name: 'El Salvador' },
    { code: 'GQ', name: 'Equatorial Guinea' },
    { code: 'ER', name: 'Eritrea' },
    { code: 'EE', name: 'Estonia' },
    { code: 'SZ', name: 'Eswatini' },
    { code: 'ET', name: 'Ethiopia' },
    { code: 'FK', name: 'Falkland Islands (Malvinas)' },
    { code: 'FO', name: 'Faroe Islands' },
    { code: 'FJ', name: 'Fiji' },
    { code: 'FI', name: 'Finland' },
    { code: 'FR', name: 'France' },
    { code: 'GF', name: 'French Guiana' },
    { code: 'PF', name: 'French Polynesia' },
    { code: 'TF', name: 'French Southern Territories' },
    { code: 'GA', name: 'Gabon' },
    { code: 'GM', name: 'Gambia' },
    { code: 'GE', name: 'Georgia' },
    { code: 'DE', name: 'Germany' },
    { code: 'GH', name: 'Ghana' },
    { code: 'GI', name: 'Gibraltar' },
    { code: 'GR', name: 'Greece' },
    { code: 'GL', name: 'Greenland' },
    { code: 'GD', name: 'Grenada' },
    { code: 'GP', name: 'Guadeloupe' },
    { code: 'GU', name: 'Guam' },
    { code: 'GT', name: 'Guatemala' },
    { code: 'GG', name: 'Guernsey' },
    { code: 'GN', name: 'Guinea' },
    { code: 'GW', name: 'Guinea-Bissau' },
    { code: 'GY', name: 'Guyana' },
    { code: 'HT', name: 'Haiti' },
    { code: 'HM', name: 'Heard Island and McDonald Islands' },
    { code: 'VA', name: 'Holy See' },
    { code: 'HN', name: 'Honduras' },
    { code: 'HK', name: 'Hong Kong' },
    { code: 'HU', name: 'Hungary' },
    { code: 'IS', name: 'Iceland' },
    { code: 'IN', name: 'India' },
    { code: 'ID', name: 'Indonesia' },
    { code: 'IR', name: 'Iran' },
    { code: 'IQ', name: 'Iraq' },
    { code: 'IE', name: 'Ireland' },
    { code: 'IM', name: 'Isle of Man' },
    { code: 'IL', name: 'Israel' },
    { code: 'IT', name: 'Italy' },
    { code: 'JM', name: 'Jamaica' },
    { code: 'JP', name: 'Japan' },
    { code: 'JE', name: 'Jersey' },
    { code: 'JO', name: 'Jordan' },
    { code: 'KZ', name: 'Kazakhstan' },
    { code: 'KE', name: 'Kenya' },
    { code: 'KI', name: 'Kiribati' },
    { code: 'KP', name: 'Korea, Democratic People\'s Republic of' },
    { code: 'KR', name: 'Korea, Republic of' },
    { code: 'KW', name: 'Kuwait' },
    { code: 'KG', name: 'Kyrgyzstan' },
    { code: 'LA', name: 'Lao People\'s Democratic Republic' },
    { code: 'LV', name: 'Latvia' },
    { code: 'LB', name: 'Lebanon' },
    { code: 'LS', name: 'Lesotho' },
    { code: 'LR', name: 'Liberia' },
    { code: 'LY', name: 'Libya' },
    { code: 'LI', name: 'Liechtenstein' },
    { code: 'LT', name: 'Lithuania' },
    { code: 'LU', name: 'Luxembourg' },
    { code: 'MO', name: 'Macao' },
    { code: 'MG', name: 'Madagascar' },
    { code: 'MW', name: 'Malawi' },
    { code: 'MY', name: 'Malaysia' },
    { code: 'MV', name: 'Maldives' },
    { code: 'ML', name: 'Mali' },
    { code: 'MT', name: 'Malta' },
    { code: 'MH', name: 'Marshall Islands' },
    { code: 'MQ', name: 'Martinique' },
    { code: 'MR', name: 'Mauritania' },
    { code: 'MU', name: 'Mauritius' },
    { code: 'YT', name: 'Mayotte' },
    { code: 'MX', name: 'Mexico' },
    { code: 'FM', name: 'Micronesia (Federated States of)' },
    { code: 'MD', name: 'Moldova (Republic of)' },
    { code: 'MC', name: 'Monaco' },
    { code: 'MN', name: 'Mongolia' },
    { code: 'ME', name: 'Montenegro' },
    { code: 'MS', name: 'Montserrat' },
    { code: 'MA', name: 'Morocco' },
    { code: 'MZ', name: 'Mozambique' },
    { code: 'MM', name: 'Myanmar' },
    { code: 'NA', name: 'Namibia' },
    { code: 'NR', name: 'Nauru' },
    { code: 'NP', name: 'Nepal' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'NC', name: 'New Caledonia' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'NI', name: 'Nicaragua' },
    { code: 'NE', name: 'Niger' },
    { code: 'NG', name: 'Nigeria' },
    { code: 'NU', name: 'Niue' },
    { code: 'NF', name: 'Norfolk Island' },
    { code: 'MP', name: 'Northern Mariana Islands' },
    { code: 'NO', name: 'Norway' },
    { code: 'OM', name: 'Oman' },
    { code: 'PK', name: 'Pakistan' },
    { code: 'PW', name: 'Palau' },
    { code: 'PS', name: 'Palestine, State of' },
    { code: 'PA', name: 'Panama' },
    { code: 'PG', name: 'Papua New Guinea' },
    { code: 'PY', name: 'Paraguay' },
    { code: 'PE', name: 'Peru' },
    { code: 'PH', name: 'Philippines' },
    { code: 'PN', name: 'Pitcairn' },
    { code: 'PL', name: 'Poland' },
    { code: 'PT', name: 'Portugal' },
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'QA', name: 'Qatar' },
    { code: 'RE', name: 'Réunion' },
    { code: 'RO', name: 'Romania' },
    { code: 'RU', name: 'Russian Federation' },
    { code: 'RW', name: 'Rwanda' },
    { code: 'BL', name: 'Saint Barthélemy' },
    { code: 'KN', name: 'Saint Kitts and Nevis' },
    { code: 'LC', name: 'Saint Lucia' },
    { code: 'MF', name: 'Saint Martin (French part)' },
    { code: 'SX', name: 'Saint Martin (Dutch part)' },
    { code: 'SM', name: 'San Marino' },
    { code: 'ST', name: 'Sao Tome and Principe' },
    { code: 'SA', name: 'Saudi Arabia' },
    { code: 'SN', name: 'Senegal' },
    { code: 'RS', name: 'Serbia' },
    { code: 'SC', name: 'Seychelles' },
    { code: 'SL', name: 'Sierra Leone' },
    { code: 'SG', name: 'Singapore' },
    { code: 'SX', name: 'Sint Maarten (Dutch part)' },
    { code: 'SK', name: 'Slovakia' },
    { code: 'SI', name: 'Slovenia' },
    { code: 'SB', name: 'Solomon Islands' },
    { code: 'SO', name: 'Somalia' },
    { code: 'ZA', name: 'South Africa' },
    { code: 'GS', name: 'South Georgia and the South Sandwich Islands' },
    { code: 'SS', name: 'South Sudan' },
    { code: 'ES', name: 'Spain' },
    { code: 'LK', name: 'Sri Lanka' },
    { code: 'SD', name: 'Sudan' },
    { code: 'SR', name: 'Suriname' },
    { code: 'SJ', name: 'Svalbard and Jan Mayen' },
    { code: 'SZ', name: 'Sweden' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'SY', name: 'Syrian Arab Republic' },
    { code: 'TW', name: 'Taiwan, Province of China' },
    { code: 'TJ', name: 'Tajikistan' },
    { code: 'TZ', name: 'Tanzania, United Republic of' },
    { code: 'TH', name: 'Thailand' },
    { code: 'TL', name: 'Timor-Leste' },
    { code: 'TG', name: 'Togo' },
    { code: 'TK', name: 'Tokelau' },
    { code: 'TO', name: 'Tonga' },
    { code: 'TT', name: 'Trinidad and Tobago' },
    { code: 'TN', name: 'Tunisia' },
    { code: 'TR', name: 'Turkey' },
    { code: 'TM', name: 'Turkmenistan' },
    { code: 'TC', name: 'Turks and Caicos Islands' },
    { code: 'TV', name: 'Tuvalu' },
    { code: 'UG', name: 'Uganda' },
    { code: 'UA', name: 'Ukraine' },
    { code: 'AE', name: 'United Arab Emirates' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'US', name: 'United States of America' },
    { code: 'UM', name: 'United States Minor Outlying Islands' },
    { code: 'UY', name: 'Uruguay' },
    { code: 'UZ', name: 'Uzbekistan' },
    { code: 'VU', name: 'Vanuatu' },
    { code: 'VE', name: 'Venezuela' },
    { code: 'VN', name: 'Viet Nam' },
    { code: 'WF', name: 'Wallis and Futuna' },
    { code: 'EH', name: 'Western Sahara' },
    { code: 'YE', name: 'Yemen' },
    { code: 'ZM', name: 'Zambia' },
    { code: 'ZW', name: 'Zimbabwe' }
  ];
  publisher: boolean = false;
  filteredCountries = this.countries;
  deployments: boolean = false;
  tags: boolean = false;
  filteredText:any;
  showContentConfiguration: boolean = false;
  publishers = [
    { name: 'Veniso', email: 'aditya@veniso.com' },
    { name: 'Sonic Signal Technology', email: 'tnyemba@sonic.com' },
    { name: 'Jive Zimbabwe', email: 'benjy@jivestore.com' },
    { name: 'Sonic Signal Technology', email: 'tnyemba@sonic.com' },
    { name: 'Jive Zimbabwe', email: 'benjy@jivestore.com' },
    { name: 'Sonic Signal Technology', email: 'tnyemba@sonic.com' },
    { name: 'Jive Zimbabwe', email: 'benjy@jivestore.com' },
    { name: 'Sonic Signal Technology', email: 'tnyemba@sonic.com' },
    { name: 'Jive Zimbabwe', email: 'benjy@jivestore.com' },
    { name: 'Sonic Signal Technology', email: 'tnyemba@sonic.com' },
    { name: 'Jive Zimbabwe', email: 'benjy@jivestore.com' },
    { name: 'Sonic Signal Technology', email: 'tnyemba@sonic.com' },
    { name: 'Jive Zimbabwe', email: 'benjy@jivestore.com' },
    { name: 'Sonic Signal Technology', email: 'tnyemba@sonic.com' },
    { name: 'Jive Zimbabwe', email: 'benjy@jivestore.com' },
    // Add more publisher data as needed
  ];

  searchTerm: string = '';
  assignSongsToParticularObj: any;
  filteredPublishers = [...this.publishers];
  pageSize: number = 10;
  currentPage: number = 1
  recordsPerPage: number = 10;
  totalEntries: number = 0;
  totalPages: number = 0;
  pages: (number | string)[] = [];
  displayedRecords: any[] = [];
  paginatedPublishers: any = [];
  openMusicAddForm: boolean = false;
  containers: boolean = false;
  Artist: boolean = false;
  Generes: boolean = false;
  tagForm: any;
  deploymentForm: any;
  artistForm: any;
  genreForm: any;
  userForm: any;
  roleForm: any;
  publisherForm: any;
  musicForm: any;
  filterForm: any;
  passwordForm: any;
  tagsListingForm: any;
  laoutForm: any;
  private subscription: Subscription = new Subscription();
  page = 0;
  size = 15;
  selectedType: string = '';
  selectedAudience: string = '';
  searchsTerm: string = '';

  constructor(private modalService: NgbModal, private tosterService: ToastrService, private sanitizer: DomSanitizer, private router: Router, private SpinnerService: NgxSpinnerService, private authService: AuthService, private fb: FormBuilder,private sharedService: SharedService) {
    // this.updatePaginatedPublishers();
    this.tagFormFunc();
    this.deploymentFormFunc();
    this.genresFormFunc();
    this.artistFormFunc();
    this.UserFormFunc();
    this.roleFormFunc();
    this.publsiherFormFunc();
    this.musicFormFunc();
    this.tagsLIstingFormFunc();
    this.fileterFormFunc();
    this.changePaaswordFormFunc();
    this.LayoutForm();
    this.PlayListForm();
  }
   PlayListForm() {
    return this.playlistForm = this.fb.group({
      playlistName: ['', Validators.required],
      playlistImage: [null, Validators.required]
    });
  }
  fileterFormFunc() {
    return this.filterForm = this.fb.group({
      publisher: [''],
      artist: [''],
      startDate: [''],
      endDate: ['']
    });
  }
  tagsLIstingFormFunc() {
    return this.tagsListingForm = this.fb.group({
      tags: [[], Validators.required]
    });
  }
  LayoutForm() {
    return this.laoutForm = this.fb.group({
      name: ['', Validators.required],
      // description: ['', Validators.required]
    });
  }
  changePaaswordFormFunc() {
    return this.passwordForm = this.fb.group({
      currentPassword: ['', Validators.required],
      newPassword: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(20),
          this.passwordStrengthValidator
        ]
      ],
      confirmPassword: ['', Validators.required],
    });
  }
  noSpecialCharactersOrEmojis(control: AbstractControl): ValidationErrors | null {
    const value = control.value || '';
    const regex = /^[a-zA-Z0-9 ]+$/; // Allows only alphanumeric characters and spaces
    return regex.test(value) ? null : { invalidCharacters: true };
  }

  passwordStrengthValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value || '';
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumeric = /\d/.test(value);
    const hasSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(value);

    const isValid = hasUpperCase && hasLowerCase && hasNumeric && hasSpecialCharacter;
    return !isValid ? { passwordStrength: true } : null;
  }
  musicFormFunc() {
    return this.musicForm = this.fb.group({
      publisher: ['', Validators.required],
      tags: [[], Validators.required],
      name: ['', [Validators.required, Validators.minLength(3)]],
      artist: ['', Validators.required],
      featuredArtist: [''],
      album: ['', Validators.required],
      language: ['', Validators.required],
      shortDescription: ['', Validators.required],
      description: [''],
      genre: ['', Validators.required],
      restrictedCountries: [[]],
      eligibleCountires: [[], Validators.required],
      musicFile: ['', Validators.required],
      crbtFile: ['', Validators.required],
      ivrFile: ['', Validators.required],
      previewImage: ['', Validators.required],
    });
  }
  publsiherFormFunc() {
    return this.publisherForm = this.fb.group({
      publisherName: ['', Validators.required],
      contactPersonName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      contactNumber: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]]
    });
  }

  UserFormFunc() {
    return this.userForm = this.fb.group({
      username: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      contactNumber: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      // countryCode: ['+1', Validators.required],
      password: ['', [Validators.required, Validators.minLength(6)]],
      role: new FormControl([], Validators.required)
    });
  }

  roleFormFunc() {
    return this.roleForm = this.fb.group({
      role: new FormControl([], Validators.required)
    });
  }

  genresFormFunc() {
    return this.genreForm = this.fb.group({
      genreName: ['', [Validators.required]]
    });
  }

  artistFormFunc() {
    return this.artistForm = this.fb.group({
      artistName: ['', [Validators.required]]
    });
  }

  tagFormFunc() {
    return this.tagForm = this.fb.group({
      tagName: ['', Validators.required],
      contentType: ['', Validators.required]
    });
  }

  deploymentFormFunc() {
    return this.deploymentForm = this.fb.group({
      deploymentName: ['', [Validators.required]]
    });
  }

  openAddForm(content: any) {
    this.passwordForm.reset();
    this.toBeEditedTagId = null
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }

  deleteModel(id: any, text: any, newText: any) {
    this.toBeDeletedId = id;
    this.ViewAllText = newText;
    this.toBeDeletedText = text;
  }

  onSubmit(event: Event) {
    event.preventDefault();
  }

  onCancel() {
    this.modalService.dismissAll();
  }

  showRoleDropdown(): boolean {
    return this.roles && this.roles.some((role: any) => role.role === 'Super Admin');
  }

  showUserDropdown(): boolean {
    return this.roles && this.roles.some((role: any) => role.role === 'Super Admin' || role.role === 'Admin');
  }

  CreateMusicPermissions(): boolean {
    return this.roles && this.roles.some((role: any) => role.role === 'Super Admin' || role.role === 'Publisher' || role.role === 'Admin');
  }

  showUserManagementDropdown(): boolean {
    return this.roles.some((role: any) => role.role === 'Super Admin' || role.role === 'Admin');
  }

  ngOnInit(): void {
    const state = history?.state;
    if (state?.fetch) {
      this.openManageNotification();
    }
    let user: any = localStorage.getItem('username');
    if (user) {
      this.userName = JSON.parse(user);
    }
    let roles: any = localStorage.getItem('role');
    if (roles) {
      this.roles = JSON.parse(roles);
    }
    // this.generatePagination();
    // this.updateEntryInfo();
    // this.getAllTags();
    // this.getAllDeployments();
    // 
    // this.getAllGeneres();
    // 
    // this.getAllUsers();
    // this.getAllPublishers();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'role',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: true,
      dropdownPosition: 'top',
    };
    this.countrySettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'countryName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: true,
      dropdownPosition: 'top',
    };
    this.tagsSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'tagName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: true,
      dropdownPosition: 'top',
    };
    this.subscription = this.sharedService.openManageNotification$.subscribe(() => {
      this.openManageNotification();
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  
  getAllLanguage() {
    this.SpinnerService.show();
    this.authService.getAllLanguages().subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.languageArray = response;
      },
      (error) => {
        this.SpinnerService.show();
        console.error(error);
      }
    );
  }
  selectTab(tab: string) {
    this.musicArray = [...this.filteredMusicArray]
    this.selectedTab = tab;
    if (tab == 'Pending') {
      tab = 'Approval Pending';
    }
    if (tab === 'All') {
      this.musicArray = [...this.filteredMusicArray];
    } else {
      this.musicArray = this.filteredMusicArray.filter((item: any) => item.status === tab);
    }
    this.totalEntries = this.musicArray.length;
    this.tabMusicArray = [...this.musicArray];
    this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
    this.setRecordsPerPage(10, this.musicArray, 'Music', 'filter_apply');
    this.musicArray = this.updateDisplayedRecords(this.musicArray, 'Music', 'filter_apply');
    this.generatePages();
  }

  // getFilteredArray(type: string): any[] {
  //   switch (type) {
  //     case 'Music':
  //       return this.musicArray;
  //     case 'Deployment':
  //       return this.deploymentsArray;
  //     case 'Artist':
  //       return this.artistArray;
  //     case 'Role':
  //       return this.roleArray
  //     case 'User':
  //       return this.userArray;
  //     case 'Genre':
  //       return this, this.genreArray
  //     case 'Tag':
  //       return this.tagsArray
  //     case 'Publisher':
  //       return this.publisherArray
  //     default:
  //       return [];
  //   }
  // }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const fileType = file.type;

      if (fileType !== 'image/png') {
        window.alert('Please upload a valid PNG file.');
        this.selectedImage = null;
        input.value = '';
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.selectedImage = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onGenreFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const fileType = file.type;

      if (fileType !== 'image/png') {
        window.alert('Please upload a valid PNG file.');
        this.selectedenereImage = null;
        input.value = '';
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.selectedenereImage = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  applySearch(text: string) {
    const trimAndLowerCase = (value: string) => value?.trim().toLowerCase() || '';

    const freeHandSearchHandler = (array: any[], filteredArray: any[]) => {
      const searchTerm = trimAndLowerCase(this.searchTerm);
      const excludeKeys = ['thumbnailUrl', 'thumbnail', 'songThumbnail', 'streamUrl'];
    
      if (searchTerm) {
        return filteredArray.filter((item) =>
          Object.entries(item).some(([key, value]: [string, any]) => {
            if (excludeKeys.includes(key)) return false; 
    
            const normalizedValue = Array.isArray(value)
              ? value.join(' ').toLowerCase()
              : String(value).toLowerCase();
    
            return normalizedValue.includes(searchTerm);
          })
        );
      }
      return [...filteredArray];
    };
    

    switch (text) {
      case 'Music':
        this.tabMusicArray = [];
        // if (this.filteredMusicArray.length == 0) {
        //   this.filteredMusicArray = [...this.musicListedArray];
        // }
        this.musicArray = freeHandSearchHandler(this.musicArray, this.musicListedArray);
        break;
      case 'newRole':
        // this.tabMusicArray = [];
        // if (this.filteredMusicArray.length == 0) {
        //   this.filteredMusicArray = [...this.musicListedArray];
        // }
        this.ListArray = freeHandSearchHandler(this.ListArray, this.listedListedArray);
        break;
      case 'Deployment':
        // if (this.deploymentsArray.length == 0) {
        //   this.deploymentsArray = [...this.deploymentListedArray];
        // }
        this.deploymentsArray = freeHandSearchHandler(this.deploymentsArray, this.deploymentListedArray);
        break;
      case 'Artist':
        // if (this.artistArray.length == 0) {
        //   this.artistArray = [...this.artistListedArray];
        // }
        this.artistArray = freeHandSearchHandler(this.artistArray, this.artistListedArray);
        break;
      case 'Role':
        let roleArray = freeHandSearchHandler(
          this.roleArray.song ? this.roleArray.songDetails :
            this.roleArray.tunes ? this.roleArray.callertuneDetails :
              this.roleArray.artist ? this.roleArray.artistDetails :
              this.roleArray.globalMIX ? this.roleArray.globalPlaylists :
                this.roleArray.genre ? this.roleArray.genres : '',
          this.roleListedArray
        );
        if (this.roleArray.song) {
          this.roleArray.songDetails = roleArray;
        } else if (this.roleArray.genre) {
          this.roleArray.genres = roleArray;
        } else if (this.roleArray.artist) {
          this.roleArray.artistDetails = roleArray;
        } else if (this.roleArray.tunes) {
          this.roleArray.callertuneDetails = roleArray;
        } else if (this.roleArray.globalMIX) {
          this.roleArray.globalPlaylists = roleArray;
        }
        break;
      case 'User':
        // if (this.userArray.length == 0) {
        //   this.userArray = [...this.userListedArray];
        // }
        this.userArray = freeHandSearchHandler(this.userArray, this.userListedArray);
        break;
      case 'Genre':
        // if (this.genreArray.length == 0) {
        //   this.genreArray = [...this.genreListedArray];
        // }
        this.genreArray = freeHandSearchHandler(this.genreArray, this.genreListedArray);
        break;
      case 'Tag':
        // if (this.tagsArray.length == 0) {
        //   this.tagsArray = [...this.tagListedArray];
        // }
        this.tagsArray = freeHandSearchHandler(this.tagsArray, this.tagListedArray);
        break;
      case 'Publisher':
        // if (this.publisherArray.length == 0) {
        //   this.publisherArray = [...this.publisherListedArray];
        // }
        this.publisherArray = freeHandSearchHandler(this.publisherArray, this.publisherListedArray);
        break;
      case 'ViewallArray':
        // if (this.publisherArray.length == 0) {
        //   this.publisherArray = [...this.publisherListedArray];
        // }
        this.viewAllArray = freeHandSearchHandler(this.viewAllArray, this.viewAllListedArray);
        break;
      default:
        break;
    }
    if (!this.searchTerm && text == 'Music') {
      this.pageSize = 10;
      this.musicArray = [...this.musicListedArray];
    }
    if (!this.searchTerm && text == 'Role') {
      this.pageSize = 10;
      if (this.roleArray.song) {
        this.roleArray.songDetails = [...this.roleListedArray];
      } else if (this.roleArray.genre) {
        this.roleArray.genres = [...this.roleListedArray];
      } else if (this.roleArray.artist) {
        this.roleArray.artistDetails = [...this.roleListedArray];
      } else if (this.roleArray.tunes) {
        this.roleArray.callertuneDetails = [...this.roleListedArray];
      } else if (this.roleArray.globalMIX) {
        this.roleArray.globalPlaylists = [...this.roleListedArray];
      }
      // this.roleArray = [...this.roleListedArray];
    }
    if (!this.searchTerm && text == 'Publisher') {
      this.pageSize = 10;
      this.publisherArray = [...this.publisherListedArray];
    }
    if (!this.searchTerm && text == 'Tag') {
      this.pageSize = 10;
      this.tagsArray = [...this.tagListedArray];
    }
    if (!this.searchTerm && text == 'Genre') {
      this.pageSize = 10;
      this.genreArray = [...this.genreListedArray];
    }
    if (!this.searchTerm && text == 'User') {
      this.pageSize = 10;
      this.userArray = [...this.userListedArray];
    }
    if (!this.searchTerm && text == 'ViewallArray') {
      this.pageSize = 10;
      this.viewAllArray = [...this.viewAllListedArray];
    }
    // if (!this.searchTerm && text == 'Role') {
    //   this.viewAllArray = [...this.viewAllListedArray];
    // }
    if (!this.searchTerm && text == 'newRole') {
      this.pageSize = 10;
      this.ListArray = [...this.listedListedArray];
    }
    if (!this.searchTerm && text == 'Artist') {
      this.pageSize = 10;
      this.artistArray = [...this.artistListedArray];
    }
    if (!this.searchTerm && text == 'Deployment') {
      this.pageSize = 10;
      this.deploymentsArray = [...this.deploymentListedArray];
    }
    // Reset pagination for every case
    this.resetPaginationAndRecords(this.searchTerm ? 'search_apply' : '', text);
  }

  resetPaginationAndRecords(text: string, title: any) {
    switch (title) {
      case 'Music':
        this.filteredMusicArray = [...this.musicArray];
        this.totalEntries = this.musicArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.musicArray, 'Music', '');
        this.musicArray = this.updateDisplayedRecords(this.musicArray, 'Music', '');
        this.generatePages();
        break;
      case 'Deployment':
        this.filteredDeployementArray = [...this.deploymentsArray];
        this.totalEntries = this.deploymentsArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.deploymentsArray, title, text);
        this.deploymentsArray = this.updateDisplayedRecords(this.deploymentsArray, title, text);
        this.generatePages();
        break;
      case 'Artist':
        this.filteredArtistArray = [...this.artistArray];
        this.totalEntries = this.artistArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.artistArray, title, text);
        this.artistArray = this.updateDisplayedRecords(this.artistArray, title, text);
        this.generatePages();
        break;
      case 'newRole':
        this.filteredListArray = [...this.ListArray];
        this.totalEntries = this.ListArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.ListArray, title, text);
        this.ListArray = this.updateDisplayedRecords(this.ListArray, title, text);
        this.generatePages();
        break;
      case 'ViewallArray':
        this.filteredViewAllArray = [...this.viewAllArray];
        this.totalEntries = this.viewAllArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.viewAllArray, title, text);
        this.viewAllArray = this.updateDisplayedRecords(this.viewAllArray, title, text);
        this.generatePages();
        break;
      case 'Role':
        // this.filteredRoleArray
        // this.roleListedArray
        if (this.roleArray.genre) {
          // if(this.roleArray.genres.length == 0){
          //   this.filteredRoleArray = [];
          // }
          this.filteredRoleArray = [...this.roleArray.genres];
          this.totalEntries = this.roleArray.genres.length;
          this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
          this.setRecordsPerPage(10, this.roleArray.genres, title, text);
          this.roleArray.genres = this.updateDisplayedRecords(this.roleArray.genres, title, text);
        }
        if (this.roleArray.song) {
          // if(this.roleArray.songDetails.length == 0){
          //   this.filteredRoleArray = [];
          // }
          this.filteredRoleArray = [...this.roleArray.songDetails];
          this.totalEntries = this.roleArray.songDetails.length;
          this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
          this.setRecordsPerPage(10, this.roleArray.songDetails, title, text);
          this.roleArray.songDetails = this.updateDisplayedRecords(this.roleArray.songDetails, title, text);
        }
        if (this.roleArray.tunes) {
          // if(this.roleArray.callertuneDetails.length == 0){
          //   this.filteredRoleArray = [];
          // }
          this.filteredRoleArray = [...this.roleArray.callertuneDetails];
          this.totalEntries = this.roleArray.callertuneDetails.length;
          this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
          this.setRecordsPerPage(10, this.roleArray.callertuneDetails, title, text);
          this.roleArray.callertuneDetails = this.updateDisplayedRecords(this.roleArray.callertuneDetails, title, text);
        }
        if (this.roleArray.globalMIX) {
          // if(this.roleArray.callertuneDetails.length == 0){
          //   this.filteredRoleArray = [];
          // }
          this.filteredRoleArray = [...this.roleArray.globalPlaylists];
          this.totalEntries = this.roleArray.globalPlaylists.length;
          this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
          this.setRecordsPerPage(10, this.roleArray.globalPlaylists, title, text);
          this.roleArray.globalPlaylists = this.updateDisplayedRecords(this.roleArray.globalPlaylists, title, text);
        }
        if (this.roleArray.artist) {
          // if(this.roleArray.artistDetails.length == 0){
          //   this.filteredRoleArray = [];
          // }
          this.filteredRoleArray = [...this.roleArray.artistDetails];
          this.totalEntries = this.roleArray.artistDetails.length;
          this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
          this.setRecordsPerPage(10, this.roleArray.artistDetails, title, text);
          this.roleArray.artistDetails = this.updateDisplayedRecords(this.roleArray.artistDetails, title, text);
        }
        this.generatePages();
        break;
      case 'User':
        this.filteredUserArray = [...this.userArray];
        this.totalEntries = this.userArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.userArray, title, text);
        this.userArray = this.updateDisplayedRecords(this.userArray, title, text);
        this.generatePages();
        break;
      case 'Genre':
        this.filteredGeneresArray = [...this.genreArray];
        this.totalEntries = this.genreArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.genreArray, title, text);
        this.genreArray = this.updateDisplayedRecords(this.genreArray, title, text);
        this.generatePages();
        break;
      case 'Tag':
        this.filteredTgasArray = [...this.tagsArray];
        this.totalEntries = this.tagsArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.tagsArray, title, text);
        this.tagsArray = this.updateDisplayedRecords(this.tagsArray, title, text);
        this.generatePages();
        break;
      case 'Publisher':
        this.filteredPublisherArray = [...this.publisherArray];
        this.totalEntries = this.publisherArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.publisherArray, title, text);
        this.publisherArray = this.updateDisplayedRecords(this.publisherArray, title, text);
        this.generatePages();
        break;
      default:
        break;
    }
  }

  onSongDetailsDrop(event: CdkDragDrop<any[]>) {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.roleArray.songDetails, event.previousIndex, event.currentIndex);
      this.roleArray.songDetails.forEach((item: any, index: any) => {
        item.newIndex = index + 1;
      });
      this.updateOrderOnServer(this.roleArray.songDetails);
    }
  }

  dropArtistDetails(event: CdkDragDrop<any[]>) {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.roleArray.artistDetails, event.previousIndex, event.currentIndex);
      this.roleArray.artistDetails.forEach((item: any, index: any) => {
        item.newIndex = index + 1;
      });
      this.updateOrderOnServer(this.roleArray.artistDetails);
    }
  }

  onDrop(event: CdkDragDrop<any[]>) {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.roleArray.callertuneDetails, event.previousIndex, event.currentIndex);
      this.roleArray.callertuneDetails.forEach((item: any, index: any) => {
        item.newIndex = index + 1;
      });
      this.updateOrderOnServer(this.roleArray.callertuneDetails);
    }
  }

  onDropContainer(event: CdkDragDrop<any[]>) {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.artistArray, event.previousIndex, event.currentIndex);
      this.artistArray.forEach((item: any, index: any) => {
        item.newIndex = index + 1;
      });
      this.updateContainerOrderOnServer(this.artistArray);
    }
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.roleArray.genres, event.previousIndex, event.currentIndex);
    this.roleArray.genres = this.roleArray.genres.map((item: any, index: any) => ({
      ...item,
      newIndex: index + 1,
    }));
    this.updateOrderOnServer(this.roleArray.genres);
  }

  dropGlobalPlayMIX(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.roleArray.globalPlaylists, event.previousIndex, event.currentIndex);
    this.roleArray.globalPlaylists = this.roleArray.globalPlaylists.map((item: any, index: any) => ({
      ...item,
      newIndex: index + 1,
    }));
    this.updateOrderOnServer(this.roleArray.globalPlaylists);
  }

  updateContainerOrderOnServer(updatedGenres: any[]) {
    this.authService.updateContainerSequence(updatedGenres.map((ele: any) => ({
      containerId: ele.id,
      sequence: ele.newIndex
    }))).subscribe({
      next: (updateResponse) => {
        this.SpinnerService.hide();
        console.log('Sequence updated successfully:', updateResponse);
      },
      error: (error) => {
        this.SpinnerService.hide();
        console.error('Error updating sequence:', error);
      },
    });
  }

  updateOrderOnServer(updatedGenres: any[]) {
    const payload = {
      containerId: this.CarosulesConetnt.id,
      carouselContent: updatedGenres.map((ele: any) => ({
        itemId: ele.id,
        sequence: ele.newIndex
      })),
    };
    this.authService.updateSequence(payload).subscribe({
      next: (updateResponse) => {
        this.SpinnerService.hide();
        console.log('Sequence updated successfully:', updateResponse);
      },
      error: (error) => {
        this.SpinnerService.hide();
        console.error('Error updating sequence:', error);
      },
    });
  }

  getAllPublishers() {
    this.SpinnerService.show();
    this.authService.getAllpublishers().subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.publisherArray = response;
        this.filteredPublisherArray = [...this.publisherArray];
        this.totalEntries = this.publisherArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.publisherArray, 'Publisher', '');
        this.publisherArray = this.updateDisplayedRecords(this.publisherArray, 'Publisher', '');
        this.generatePages();
      },
      (error) => {
        this.SpinnerService.show();
        console.error(error);
      }
    );
  }
  getAllMusic() {
    this.SpinnerService.show();
    if (this.muiscId) {
      let propMap: { [key: string]: string } = {
        UPCOMING_ARTIST: 'artistDetails',
        TOP_GENRES: 'genres',
        VALENTINES_LOVE_SONGS: 'songDetails',
        POPULAR_PARTY_HITS: 'songDetails',
        ROMANTIC_TUNES: 'callertuneDetails',
        PARTY_TUNES: 'callertuneDetails'
      };
      let propKey: any;
      propKey = propMap[this.CarosulesConetnt?.name];
      if (!propKey) {
        console.error(`Invalid name parameter: ${this.CarosulesConetnt?.name}`);
        this.SpinnerService.hide();
        return;
      }
      this.PropName = this.CarosulesConetnt?.name;
      if (['VALENTINES_LOVE_SONGS', 'POPULAR_PARTY_HITS', 'ROMANTIC_TUNES', 'PARTY_TUNES'].includes(this.CarosulesConetnt?.name)) {
        this.authService.AddContent(this.CarosulesConetnt?.name, this.CarosulesConetnt?.id).subscribe(
          (response) => {
            this.SpinnerService.hide();
            this.musicArray = response.data[propKey] || [];
            this.musicListedArray = [...this.musicArray];
            this.initializeMusicArray();
            if(environment.preprod){
              setTimeout(() => {
                this.SpinnerService.hide();
              }, 1000);
            }else{
              this.SpinnerService.hide();
            }
          },
          (error) => {
            this.SpinnerService.hide();
            console.error(error);
          }
        );
        this.deployments = !this.deployments;
        this.muiscId = null;
      }
    } else {
      this.authService.getAllMusics(this.filteredText=='viewSongs' ? this.publisherSongs : '', this.openConetnt ? '' : this.CarosulesConetnt?.name).subscribe(
        (response) => {
          let nextext = this.openConetnt ? 'songDetails' : (this.CarosulesConetnt?.name == 'PARTY_TUNES' || this.CarosulesConetnt?.name == 'ROMANTIC_TUNES') ? 'callertuneDetails' : 'songDetails';
          this.musicArray = response.data[nextext] || [];
          this.SpinnerService.hide();
          this.selectedTab = 'All';
          this.musicArray.forEach((music: any) => {
            music.checked = false;
            const resourceWithFileType4 = music.releaseResources?.find((res: any) => res.fileTypeId == 4);
            if (resourceWithFileType4) {
              music.image = resourceWithFileType4.downloadUrl;
            }
          });
          this.filteredMusicArray = [...this.musicArray];
          this.openConetnt = false;
          this.musicListedArray = [...this.filteredMusicArray];
          this.totalEntries = this.musicArray.length;
          this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
          this.setRecordsPerPage(10, this.musicArray, 'Music', '');
          this.musicArray = this.updateDisplayedRecords(this.musicArray, 'Music', '');
          this.generatePages();
        },
        (error) => {
          this.SpinnerService.hide();
          console.error(error);
        }
      );
    }
    this.filteredMusicArray.forEach((publisher: any) => {
      publisher.checked = false;
    });
    this.musicArray.forEach((publisher: any) => {
      publisher.checked = false;
    });
  }

  initializeMusicArray() {
    this.filteredMusicArray = [...this.musicArray];
    this.totalEntries = this.musicArray.length;
    this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
    this.setRecordsPerPage(10, this.musicArray, 'Music', '');
    this.musicArray = this.updateDisplayedRecords(this.musicArray, 'Music', '');
    this.generatePages();
  }

  getAllUsers() {
    this.SpinnerService.show();
    this.authService.getAllUsers().subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.userArray = response;
        this.filteredUserArray = [...this.userArray];
        this.totalEntries = this.userArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.userArray, 'User', '');
        this.userArray = this.updateDisplayedRecords(this.userArray, 'User', '');
        this.generatePages();
      },
      (error) => {
        this.SpinnerService.show();
        console.error(error);
      }
    );
  }

getAllRoles(id: any) {
  this.selectedCaroselsId = id;
    this.SpinnerService.show();
     this.authService.getAllRoles(id).subscribe(
      (response) => {
        if(response.status){
          this.SpinnerService.hide();
          let itemsAdded = false;
          let carouselContent;
          if (this.ListArray.length) {
            this.ListArray.forEach((item: any) => {
              if (item.checked) {
                if (response.data.genres) {
                  const exists = response.data.genres.some((existingItem: any) => existingItem.id === item.id);
                  if (!exists) {
                    response.data.genres.push(item);
                  }
                  itemsAdded = true;
                  carouselContent = response.data.genres.map((item: any, index: number) => ({
                    itemId: item.id,
                    sequence: index,
                  }));
                } else if (response.data.songDetails) {
                  const exists = response.data.songDetails.some((existingItem: any) => existingItem.id === item.id);
                  if (!exists) {
                    response.data.songDetails.push(item);
                  }
                  itemsAdded = true;
                  carouselContent = response.data.songDetails.map((item: any, index: number) => ({
                    itemId: item.id,
                    sequence: index,
                  }));
                }
                else if (response.data.globalPlaylists) {
                  const exists = response.data.globalPlaylists.some((existingItem: any) => existingItem.id === item.id);
                  if (!exists) {
                    response.data.globalPlaylists.push(item);
                  }
                  itemsAdded = true;
                  carouselContent = response.data.globalPlaylists.map((item: any, index: number) => ({
                    itemId: item.id,
                    sequence: index,
                  }));
                } else if (response.data.artistDetails) {
                  const exists = response.data.artistDetails.some((existingItem: any) => existingItem.id === item.id);
                  if (!exists) {
                    response.data.artistDetails.push(item);
                  }
                  itemsAdded = true;
                  carouselContent = response.data.artistDetails.map((item: any, index: number) => ({
                    itemId: item.id,
                    sequence: index,
                  }));
                }
                // Set `checked` to false
                item.checked = false;
              }
            });
          }
          else if (this.viewAllArray.length){
            this.viewAllArray.forEach((item: any) => {
              if (item.checked) {
               if (response.data.globalPlaylists) {
                  const exists = response.data.globalPlaylists.some((existingItem: any) => existingItem.id === item.id);
                  if (!exists) {
                    response.data.globalPlaylists.push(item);
                  }
                  itemsAdded = true;
                  carouselContent = response.data.globalPlaylists.map((item: any, index: number) => ({
                    itemId: item.id,
                    sequence: index,
                  }));
                }      
              }
            });
          }
           else {
            this.musicArray.forEach((item: any) => {
              if (item.checked) {
                if (response.data.genres) {
                  const exists = response.data.genres.some((existingItem: any) => existingItem.id === item.id);
                  if (!exists) {
                    response.data.genres.push(item);
                  }
                  itemsAdded = true;
                  carouselContent = response.data.genres.map((item: any, index: number) => ({
                    itemId: item.id,
                    sequence: index,
                  }));
                } else if (response.data.songDetails) {
                  const exists = response.data.songDetails.some((existingItem: any) => existingItem.id === item.id);
                  if (!exists) {
                    response.data.songDetails.push(item);
                  }
                  itemsAdded = true;
                  carouselContent = response.data.songDetails.map((item: any, index: number) => ({
                    itemId: item.id,
                    sequence: index,
                  }));
                }
                else if (response.data.globalPlaylists) {
                  const exists = response.data.globalPlaylists.some((existingItem: any) => existingItem.id === item.id);
                  if (!exists) {
                    response.data.globalPlaylists.push(item);
                  }
                  itemsAdded = true;
                  carouselContent = response.data.globalPlaylists.map((item: any, index: number) => ({
                    itemId: item.id,
                    sequence: index,
                  }));
                }
                else if (response.data.callertuneDetails) {
                  const exists = response.data.callertuneDetails.some((existingItem: any) => existingItem.id === item.id);
                  if (!exists) {
                    response.data.callertuneDetails.push(item);
                  }
                  itemsAdded = true;
                  carouselContent = response.data.callertuneDetails.map((item: any, index: number) => ({
                    itemId: item.id,
                    sequence: index,
                  }));
                }
                else if (response.data.artistDetails) {
                  const exists = response.data.artistDetails.some((existingItem: any) => existingItem.id === item.id);
                  if (!exists) {
                    response.data.artistDetails.push(item);
                  }
                  itemsAdded = true;
                  carouselContent = response.data.artistDetails.map((item: any, index: number) => ({
                    itemId: item.id,
                    sequence: index,
                  }));
                }
                // Set `checked` to false
                item.checked = false;
              }
            });
          }
          // Call `updateSequence` API if items were added
          if (itemsAdded) {
            const payload = {
              containerId: id,
              carouselContent: this.itemsArray,
            };
            this.authService.updateSequence(payload).subscribe(
              (updateResponse) => {
                this.authService.getAllRoles(id).subscribe((response) => {
                  this.viewAllArray = [];
                  if (response.data) {
                    if (response.data.globalPlaylists && response.data.globalPlaylists.length) {
                      this.globalPlaylistsArray = response.data.globalPlaylists;
                    }
                    if (response.data.callertuneDetails && response.data.callertuneDetails.length) {
                      this.callertuneDetails = response.data.callertuneDetails;
                    }
                    if (response.data.genres && response.data.genres.length) {
                      this.genres = response.data.genres;
                    }
                    if (response.data.artistDetails && response.data.artistDetails.length) {
                      this.artistDetails = response.data.artistDetails;
                    }
                    const {
                      songDetails = [],
                      genres = [],
                      artistDetails = [],
                      callertuneDetails = [],
                      globalPlaylists = [],
                    } = response.data;
  
                    const isSong =
                      (Array.isArray(songDetails) && songDetails.length > 0);
                    const isTunes = (Array.isArray(callertuneDetails) && callertuneDetails.length > 0);
                    const isGenre = Array.isArray(genres) && genres.length > 0;
                    const isArtist = Array.isArray(artistDetails) && artistDetails.length > 0;
                    const isPlayLIst = Array.isArray(globalPlaylists) && globalPlaylists.length > 0;
  
                    this.roleArray = {
                      ...response.data,
                      song: isSong && !isGenre && !isArtist && !isTunes && !isPlayLIst,
                      tunes: !isSong && !isGenre && !isArtist && isTunes && !isPlayLIst,
                      genre: isGenre && !isSong && !isArtist && !isTunes && !isPlayLIst,
                      artist: isArtist && !isSong && !isGenre && !isTunes && !isPlayLIst,
                      globalMIX: !isArtist && !isSong && !isGenre && !isTunes && isPlayLIst,
                    };
                    ['songDetails', 'genres', 'artistDetails', 'callertuneDetails', 'globalPlaylists'].forEach((key) => {
                      if (Array.isArray(this.roleArray[key]) && this.roleArray[key].length > 0) {
                        this.filteredRoleArray = [...this.roleArray[key]];
                        this.roleListedArray = [...this.filteredRoleArray];
                        this.totalEntries = this.roleArray[key].length;
                        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
                        this.setRecordsPerPage(10, this.roleArray[key], 'Role', '');
                        this.roleArray = {
                          [key]: [...this.updateDisplayedRecords(
                            this.roleArray[key],
                            'Role',
                            ''
                          )],
                          song: key === 'songDetails',
                          tunes: key === 'callertuneDetails',
                          genre: key === 'genres',
                          artist: key === 'artistDetails',
                          globalMIX: key === 'globalPlaylists',
                        };
                        this.generatePages();
                      }
                    });
                  } else {
                    this.roleArray = [];
                  }
                  const roleKeys = ["callertuneDetails", "songDetails", "artistDetails", "genres", "globalPlaylists"];
                  const toggleKeys = ["tunes", "song", "artist", "genre","globalMIX"];
                  roleKeys.forEach((key, index) => {
                    if (this.roleArray[key] && this.roleArray[key]?.length === 0) {
                      toggleKeys.forEach((toggle, i) => {
                        this.roleArray[toggle] = i === index;
                      });
                    }
                  });
                });
                this.SpinnerService.hide();
              },
              (error) => {
                this.SpinnerService.hide();
                console.error(error);
              }
            );
          }
          // Additional processing for response data
          if (response.data) {
            if (response.data.songDetails && response.data.songDetails.length) {
              this.songDetailsArray = response.data.songDetails;
            }
             if (response.data.globalPlaylists && response.data.globalPlaylists.length) {
              this.globalPlaylistsArray = response.data.globalPlaylists;
            }
            if (response.data.callertuneDetails && response.data.callertuneDetails.length) {
              this.callertuneDetails = response.data.callertuneDetails;
            }
            if (response.data.genres && response.data.genres.length) {
              this.genres = response.data.genres;
            }
            if (response.data.artistDetails && response.data.artistDetails.length) {
              this.artistDetails = response.data.artistDetails;
            }
            const {
              songDetails = [],
              genres = [],
              artistDetails = [],
              callertuneDetails = [],
              globalPlaylists = [],
            } = response.data;
  
            const isSong =
              (Array.isArray(songDetails) && songDetails.length > 0);
            const isTunes = (Array.isArray(callertuneDetails) && callertuneDetails.length > 0);
            const isGenre = Array.isArray(genres) && genres.length > 0;
            const isArtist = Array.isArray(artistDetails) && artistDetails.length > 0;
            const isPlayLIst = Array.isArray(globalPlaylists) && globalPlaylists.length > 0;
  
            this.roleArray = {
              ...response.data,
              song: isSong && !isGenre && !isArtist && !isTunes && !isPlayLIst,
              tunes: !isSong && !isGenre && !isArtist && isTunes && !isPlayLIst,
              genre: isGenre && !isSong && !isArtist && !isTunes && !isPlayLIst,
              artist: isArtist && !isSong && !isGenre && !isTunes && !isPlayLIst,
              globalMIX: !isArtist && !isSong && !isGenre && !isTunes && isPlayLIst,
            };
            ['songDetails', 'genres', 'artistDetails', 'callertuneDetails','globalPlaylists'].forEach((key) => {
              if (Array.isArray(this.roleArray[key]) && this.roleArray[key].length > 0) {
                this.filteredRoleArray = [...this.roleArray[key]];
                this.roleListedArray = [...this.filteredRoleArray];
                this.totalEntries = this.roleArray[key].length;
                this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
                this.setRecordsPerPage(10, this.roleArray[key], 'Role', '');
                // this.roleArray = this.updateDisplayedRecords(
                //   this.roleArray[key],
                //   'Role',
                //   ''
                // );
                this.roleArray = {
                  [key]: [...this.updateDisplayedRecords(
                    this.roleArray[key],
                    'Role',
                    ''
                  )],
                  song: key === 'songDetails',
                  globalMIX: key === 'globalPlaylists',
                  tunes: key === 'callertuneDetails',
                  genre: key === 'genres',
                  artist: key === 'artistDetails',
                };
                this.generatePages();
              }
            });
          } else {
            this.roleArray = [];
          }
          const roleKeys = ["callertuneDetails", "songDetails", "artistDetails", "genres",'globalPlaylists'];
          const toggleKeys = ["tunes", "song", "artist", "genre",'globalMIX'];
          roleKeys.forEach((key, index) => {
            if (this.roleArray[key] && this.roleArray[key]?.length === 0) {
              toggleKeys.forEach((toggle, i) => {
                this.roleArray[toggle] = i === index;
              });
            }
          });
        }else{
          const roleMap: Record<string, Partial<typeof this.roleArray>> = {
            'VALENTINES_LOVE_SONGS': { song: true, songDetails: [] },
            'POPULAR_PARTY_HITS': { song: true, songDetails: [] },
            'ROMANTIC_TUNES': { tunes: true, callertuneDetails: [] },
            'PARTY_TUNES': { tunes: true, callertuneDetails: [] },
            'GLOBAL_MIX': { globalMIX: true, globalPlaylists: [] },
            'TOP_GENRES': { genre: true, genres: [] },
            'UPCOMING_ARTIST': { artist: true, artistDetails: [] }
          };
          
          const defaultRoles = { song: false, tunes: false, genre: false, artist: false,globalMIX:false };
          
          const role = roleMap[this.CarosulesConetnt.name] || {};
          this.roleArray = { ...defaultRoles, ...role };
           // Ensure arrays are reset when switching roles
          if ('songDetails' in role) this.songDetailsArray = [];
          if ('callertuneDetails' in role) this.callertuneDetails = [];
          if ('genres' in role) this.genres = [];
          if ('artistDetails' in role) this.artistDetails = [];
          if ('globalPlaylists' in role) this.globalPlaylists = [];
          this.tosterService.error(response.message);
          this.SpinnerService.hide();
        }
      },
      (error) => {
        this.tosterService.error(error.error.message);
        this.SpinnerService.hide();
        console.error(error);
      }
    );
  }

  isGray(name: string): boolean {
    return ['RECENTLY_PLAYED', 'NAME_TUNE', 'MOST_PLAYED', 'JUST_FOR_YOU', 'TOP_GENRES', 'TOP_50_TUNES', 'ALL_TIME_FAVOURTIE', 'TRENDING_ALBUMS', 'NEW_RELEASES', 'BROWSE'].includes(name);
  }
  moveToCarasoluesContent(name: any) {
    if (name.name != 'RECENTLY_PLAYED' && name.name != 'MOST_PLAYED' && name.name != 'TOP_GENRES' && name.name != 'NAME_TUNE' && name.name != 'JUST_FOR_YOU' && name.name != 'TOP_50_TUNES' && name.name != 'ALL_TIME_FAVOURTIE' && name.name != 'TRENDING_ALBUMS' && name.name != 'BROWSE' && name.name != 'NEW_RELEASES') {
      this.CarosulesConetnt = name;
      this.pages = [];
      this.roleArray = [];
      this.totalEntries = 0;
      this.getAllRoles(name.id);
      this.showContentConfiguration = false;
      this.tags = false;
      this.role = !this.role;
      this.user = false;
      this.containers = false;
      this.deployments = false;
      this.publisher = false;
      this.music = false;
      this.conentApproval = false;
      this.Artist = false;
      this.Generes = false;
    }
  }

  // returnFunc() {
  //   if (this.CarosulesConetnt.name == 'ROMANTIC_TUNES' || this.CarosulesConetnt.name == 'PARTY_TUNES') {
  //    this.moveToContainers(this.CarosulesConetnt.name);
  //   }
  // }

  moveToViewALLContent(name: any) {
    if (name.name != 'RECENTLY_PLAYED' && name.name != 'MOST_PLAYED' && name.name != 'NAME_TUNE' && name.name != 'JUST_FOR_YOU' && name.name != 'TOP_50_TUNES' && name.name != 'ALL_TIME_FAVOURTIE' && name.name != 'TRENDING_ALBUMS' && name.name != 'BROWSE' && name.name != 'NEW_RELEASES') {
      this.pages = [];
      this.viewAllName = name;
      this.roleArray = [];
      this.totalEntries = 0;
      this.getViewAll(name.id, name.name);
      this.showContentConfiguration = false;
      this.tags = false;
      this.role = false;
      this.user = false;
      this.containers = false;
      this.deployments = false;
      this.publisher = false;
      this.music = false;
      this.conentApproval = !this.conentApproval;
      this.Artist = false;
      this.Generes = false;
    }
  }
  funcName(name: any): string {
    switch (name.name) {
      case 'NEW_RELEASES':
      case 'TRENDING_ALBUMS':
      case 'JUST_FOR_YOU':
        return 'Album';

      case 'TOP_GENRES':
        return 'Genre';

      case 'UPCOMING_ARTIST':
      case 'ALL_TIME_FAVOURTIE':
        return 'Artist';

      case 'RECENTLY_PLAYED':
      case 'MOST_PLAYED':
      case 'POPULAR_PARTY_HITS':
      case 'VALENTINES_LOVE_SONGS':
      case 'BROWSE':
        return 'Song';
      case 'ROMANTIC_TUNES':
      case 'TOP_50_TUNES':
      case 'PARTY_TUNES':
        return 'Callertune';
      default:
        return 'Unknown';
    }
  }

  funcsName(name: any): string {
    switch (name.name) {
      case 'JUST_FOR_YOU':
        return 'Callertune';
      default:
        return 'Unknown';
    }
  }

  moveToAssignSongs(name: any, text: any) {
    this.selectAll = false
    if (text != 'addContent') {
      this.addContent = false;
      if (name.name != 'RECENTLY_PLAYED' &&
        name.name != 'MOST_PLAYED' &&
        name.name != 'TOP_GENRES' &&
        name.name != 'ALL_TIME_FAVOURTIE' &&
        name.name != 'TRENDING_ALBUMS' &&
        name.name != 'JUST_FOR_YOU' &&
        name.name != 'TOP_50_TUNES' &&
        name.name != 'BROWSE' &&
        name.name != 'NEW_RELEASES' &&
        name.name != 'NAME_TUNE') {
        if (name.name == 'VALENTINES_LOVE_SONGS' || text == 'addsongs' || text == 'viewSongs' || name.name == 'POPULAR_PARTY_HITS' || name.name == 'ROMANTIC_TUNES' || name.name == 'PARTY_TUNES') {
          // this.muiscId = name.id;
          this.filteredText = text;
          this.assignSongsToParticularObj = name;
          this.CarosulesConetnt = name;
          this.openViewContent();
        } else {
          this.showFilteredOptions = false;
          this.pages = [];
          this.roleArray = [];
          this.totalEntries = 0;
          this.assignSongsToParticularObj = name;
          this.getAllAssignSongs(name.name);
          this.showContentConfiguration = false;
          this.tags = false;
          this.role = false;
          this.user = false;
          this.containers = false;
          this.conentApproval = false;
          this.publisher = false;
          this.music = false;
          this.Artist = false;
          this.Generes = false;
        }
      }
    } else {
      this.addContent = true;
      if (this.CarosulesConetnt?.name != 'RECENTLY_PLAYED' &&
        this.CarosulesConetnt?.name != 'MOST_PLAYED' &&
        this.CarosulesConetnt?.name != 'TOP_GENRES' &&
        this.CarosulesConetnt?.name != 'ALL_TIME_FAVOURTIE' &&
        this.CarosulesConetnt?.name != 'TRENDING_ALBUMS' &&
        this.CarosulesConetnt?.name != 'JUST_FOR_YOU' &&
        this.CarosulesConetnt?.name != 'TOP_50_TUNES' &&
        this.CarosulesConetnt?.name != 'BROWSE' &&
        this.CarosulesConetnt?.name != 'NEW_RELEASES' &&
        this.CarosulesConetnt?.name != 'NAME_TUNE') {
        this.muiscId = name.id;
        // this.addContent = true;
        if (this.CarosulesConetnt?.name == 'VALENTINES_LOVE_SONGS' || this.CarosulesConetnt?.name == 'GLOBAL_MIX' || this.CarosulesConetnt?.name == 'ROMANTIC_TUNES' || this.CarosulesConetnt?.name == 'PARTY_TUNES' || this.CarosulesConetnt?.name == 'POPULAR_PARTY_HITS') {
          this.assignSongsToParticularObj = this.CarosulesConetnt?.name;
          this.openViewContent();
        } else {
          this.pages = [];
          this.roleArray = [];
          this.totalEntries = 0;
          this.assignSongsToParticularObj = this.CarosulesConetnt?.name;
          this.AddContent(this.CarosulesConetnt?.name, name, this.CarosulesConetnt?.id);
          this.showContentConfiguration = false;
          this.tags = false;
          this.role = false;
          this.user = false;
          this.containers = false;
          this.conentApproval = false;
          this.publisher = false;
          this.music = false;
          this.Artist = false;
          this.Generes = false;
        }
      }
    }
  }
  getAllArtists(name: any) {
    this.storedName = name;
    this.artistArray = [];
    this.SpinnerService.show()
    this.authService.getAllArtists((name == 'Search tab') ? 'SEARCH' :
      name == 'Callertunes' ? 'CALLER_TUNE' : 'HOME').subscribe(
        (response) => {
          this.SpinnerService.hide();
          this.artistArray = response.data;
          this.filteredArtistArray = [...this.artistArray];
          this.artistListedArray = [...this.filteredArtistArray];
          this.totalEntries = this.artistArray.length;
          this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
          this.setRecordsPerPage(10, this.artistArray, 'Artist', '');
          this.artistArray = this.updateDisplayedRecords(this.artistArray, 'Artist', '');
          this.generatePages();
        },
        (error) => {
          this.SpinnerService.show();
          console.error(error);
        }
      );
  }

  getAllGeneres() {
    this.SpinnerService.show();
    this.authService.getAllGeneres().subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.genreArray = response;
        this.filteredGeneresArray = [...this.genreArray];
        this.totalEntries = this.genreArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.genreArray, 'Genre', '');
        this.genreArray = this.updateDisplayedRecords(this.genreArray, 'Genre', '');
        this.generatePages();
      },
      (error) => {
        this.SpinnerService.show();
        console.error(error);
      }
    );
  }
  getAllDeployments() {
    this.SpinnerService.show();
    this.authService.getAllDeployments().subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.deploymentsArray = response;
        this.filteredDeployementArray = [...this.deploymentsArray];
        this.totalEntries = this.deploymentsArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.deploymentsArray, 'Deployment', '');
        this.deploymentsArray = this.updateDisplayedRecords(this.deploymentsArray, 'Deployment', '');
        this.generatePages();
      },
      (error) => {
        this.SpinnerService.show();
        console.error(error);
      }
    );
  }
  getAllTags() {
    // this.SpinnerService.show();
    this.tagsArray = [
      { name: 'Home', description: 'Home' },
      { name: 'Search tab', description: 'Search tab' },
      { name: 'Callertunes', description: 'Caller tunes' },
    ];
    this.filteredTgasArray = [...this.tagsArray];
    this.tagListedArray = [...this.filteredTgasArray];
    this.totalEntries = this.tagsArray.length;
    this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
    this.setRecordsPerPage(10, this.tagsArray, 'Tag', '');
    this.tagsArray = this.updateDisplayedRecords(this.tagsArray, 'Tag', '');
    this.generatePages();

    // this.filteredTgasArray = [];
    // this.filteredTgasArray = this.tagsArray;

    // this.authService.getAllTags().subscribe(
    //   (response) => {
    //     this.SpinnerService.hide();
    //     this.tagsArray = response;
    //     this.filteredTgasArray = [...this.tagsArray];
    //     this.totalEntries = this.tagsArray.length;
    //     this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
    //     this.setRecordsPerPage(10, this.tagsArray, 'Tag', '');
    //     this.tagsArray = this.updateDisplayedRecords(this.tagsArray, 'Tag', '');
    //     this.generatePages();
    //   },
    //   (error) => {
    //     this.SpinnerService.show();
    //     console.error(error);
    //   }
    // );
  }


  getViewAll(name: any, text: any) {
    this.ListArray = [];
    const propMap: { [key: string]: string } = {
      UPCOMING_ARTIST: 'artistDetails',
      TOP_GENRES: 'genres',
      VALENTINES_LOVE_SONGS: 'songDetails',
      POPULAR_PARTY_HITS: 'songDetails',
      ROMANTIC_TUNES: 'callertuneDetails',
      PARTY_TUNES: 'callertuneDetails',
      GLOBAL_MIX: 'globalPlaylists',
    };
    // Check if the name exists in the propMap
    if (!propMap[text]) {
      console.error(`Invalid name parameter: ${name}`);
      return; // Exit if the name is not valid
    }
    this.TewxtName = text;
    this.SpinnerService.show();
    this.authService.getViewAll(name,text).subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.viewAllArray = response.data[propMap[text]] || [];
        this.pageSize = 10;
        this.filteredViewAllArray = [...this.viewAllArray];
        this.viewAllListedArray = [...this.filteredViewAllArray];
        this.totalEntries = this.viewAllArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.viewAllArray, 'ViewallArray', '');
        this.viewAllArray = this.updateDisplayedRecords(this.viewAllArray, 'ViewallArray', '');
        this.generatePages();
      },
      (error) => {
        this.SpinnerService.hide();
        console.error(error);
      }
    );

  }

  getAllCountry(name: any) {
    const propMap: { [key: string]: string } = {
      UPCOMING_ARTIST: 'artistDetails',
      TOP_GENRES: 'genres',
      VALENTINES_LOVE_SONGS: 'songDetails',
      POPULAR_PARTY_HITS: 'songDetails',
    };

    // Check if the name exists in the propMap
    if (!propMap[name]) {
      console.error(`Invalid name parameter: ${name}`);
      return; // Exit if the name is not valid
    }

    this.PropName = name;
    this.SpinnerService.show();

    this.authService.getAllCountry(name).subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.countryArray = response.data[propMap[name]] || [];
        this.updateCountryArray();
      },
      (error) => {
        this.SpinnerService.hide();
        console.error(error);
      }
    );

  }

  getAllAssignSongs(name: any) {
    this.ListArray = [];
    const propMap: { [key: string]: string } = {
      UPCOMING_ARTIST: 'artistDetails',
      TOP_GENRES: 'genres',
      VALENTINES_LOVE_SONGS: 'songDetails',
      POPULAR_PARTY_HITS: 'songDetails',
      GLOBAL_MIX: 'globalPlaylists',
    };

    if (!propMap[name]) {
      console.error(`Invalid name parameter: ${name}`);
      return;
    }

    this.PropName = name;
    this.SpinnerService.show();
    if (name != 'VALENTINES_LOVE_SONGS' && name != 'POPULAR_PARTY_HITS') {
      this.authService.getAllCountry(name).subscribe(
        (response) => {
          this.SpinnerService.hide();
          this.ListArray = response.data[propMap[name]] || [];
          this.filteredListArray = [...this.ListArray];
          this.listedListedArray = [...this.filteredListArray];
          this.totalEntries = this.ListArray.length;
          this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
          this.setRecordsPerPage(10, this.ListArray, 'assign', '');
          this.ListArray = this.updateDisplayedRecords(this.ListArray, 'assign', '');
          this.ListArray.forEach((music: any) => {
            music.checked = false;
          });
          this.generatePages();
        },
        (error) => {
          this.SpinnerService.hide();
          console.error(error);
        }
      );
      this.deployments = !this.deployments;
    }
    // else{
    //   this.openViewContent();
    // }
  }

  AddContent(name: any, obj: any, id: any) {

    const propMap: { [key: string]: string } = {
      UPCOMING_ARTIST: 'artistDetails',
      TOP_GENRES: 'genres',
      VALENTINES_LOVE_SONGS: 'songDetails',
      POPULAR_PARTY_HITS: 'songDetails',
    };

    if (!propMap[name]) {
      console.error(`Invalid name parameter: ${name}`);
      return;
    }
    this.PropName = name;
    this.SpinnerService.show();
    if (name != 'VALENTINES_LOVE_SONGS' && name != 'POPULAR_PARTY_HITS') {
      this.authService.AddContent(name, id).subscribe(
        (response) => {
          this.SpinnerService.hide();
          this.ListArray = response.data[propMap[name]] || [];
          this.filteredListArray = [...this.ListArray];
          this.listedListedArray = [...this.filteredListArray];
          this.totalEntries = this.ListArray.length;
          this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
          this.setRecordsPerPage(10, this.ListArray, 'assign', '');
          this.ListArray = this.updateDisplayedRecords(this.ListArray, 'assign', '');
          this.generatePages();
        },
        (error) => {
          this.SpinnerService.hide();
          console.error(error);
        }
      );
      this.deployments = !this.deployments;
    }
    // else{
    //   this.openViewContent();
    // }
  }

  private updateCountryArray() {
    this.filteredCountryArray = [...this.countryArray];
    this.totalEntries = this.countryArray.length;
    this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
    this.setRecordsPerPage(10, this.countryArray, 'Country', '');
    this.countryArray = this.updateDisplayedRecords(this.countryArray, 'Country', '');
    this.generatePages();
  }

  generatePagination() {
    const pages: (number | string)[] = [];
    if (this.totalPages <= 10) {
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1, 2, 3);
      if (this.currentPage > 4) {
        pages.push('...');
      }

      const start = Math.max(4, this.currentPage - 1);
      const end = Math.min(this.totalPages - 3, this.currentPage + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (this.currentPage < this.totalPages - 3) {
        pages.push('...');
      }

      pages.push(this.totalPages - 2, this.totalPages - 1, this.totalPages);
    }
    this.pages = pages;
  }

  openprofilePopup() {
    this.openConfirmChnagePopup = !this.openConfirmChnagePopup;
  }

  openViewContent() {
    this.filterForm.reset();
    this.pages = [];
    this.totalEntries = 0;
    this.authService.getAllCountry('UPCOMING_ARTIST').subscribe(
      (response) => {
        this.artistArray = response.data['artistDetails'] || [];
      },
      (error) => {
        console.error(error);
      }
    );
    this.getAllMusic();
    this.showContentConfiguration = false;
    this.music = true;
    this.deployments = false;
    this.containers = false;
    this.tags = false;
    this.publisher = false;
    this.conentApproval = false;
    this.Artist = false;
    this.Generes = false;
    this.role = false;
    this.user = false;
    this.manageNotification = false;
  }
  opeContainers() {
    this.showContentConfiguration = false;
    this.containers = !this.containers;
    this.deployments = false;
    this.music = false;
    this.conentApproval = false;
    this.tags = false;
    this.publisher = false;
    this.Artist = false;
    this.Generes = false;
    this.role = false;
    this.user = false;
  }
  errorMessage: any;
  preventSpace(event: KeyboardEvent): void {
    const inputElement = event.target as HTMLInputElement; // Get the input element
    const currentValue = inputElement.value.trim(); // Get the current value of the input

    if (event.key === ' ') {
      if (currentValue.length === 0) {
        event.preventDefault(); // Prevent space if no characters exist
        this.errorMessage = 'Spaces are not allowed before any character.';
      } else {
        this.errorMessage = ''; // Clear the error message if valid
      }
    } else {
      this.errorMessage = ''; // Clear the error for other keys
    }
  }
  opeTags() {
    this.pages = [];
    this.totalEntries = 0;
    this.getAllTags();
    this.showContentConfiguration = false;
    this.tags = true;
    this.containers = false;
    this.deployments = false;
    this.publisher = false;
    this.music = false;
    this.conentApproval = false;
    this.Artist = false;
    this.Generes = false;
    this.role = false;
    this.user = false;
    this.manageNotification = false;
  }
  opeUsers() {
    this.pages = [];
    this.totalEntries = 0;
    this.getAllUsers();

    this.showContentConfiguration = false;
    this.tags = false
    this.containers = false;
    this.deployments = false;
    this.publisher = false;
    this.music = false;
    this.user = !this.user;
    this.role = false;
    this.conentApproval = false;
    this.Artist = false;
    this.Generes = false;
  }
  opeRoles() {
    this.pages = [];
    this.totalEntries = 0;

    this.showContentConfiguration = false;
    this.tags = false;
    this.role = !this.role;
    this.user = false;
    this.containers = false;
    this.deployments = false;
    this.publisher = false;
    this.music = false;
    this.conentApproval = false;
    this.Artist = false;
    this.Generes = false;
  }
  openMuisc() {
    this.pages = [];
    this.totalEntries = 0;
    this.getAllMusic();
    this.getAllGeneres();
    // // 
    // this.getAllCountry();
    this.getAllPublishers();
    this.getAllTags();
    this.getAllLanguage();
    this.showContentConfiguration = false;
    this.music = !this.music;
    this.conentApproval = false;
    this.openMusicAddForm = false;
    this.deployments = false;
    this.publisher = false;
    this.tags = false;
    this.containers = false;
    this.Artist = false;
    this.Generes = false;
    this.role = false;
    this.user = false;
  }
  openconentApproval() {
    this.tags = false;
    this.containers = false;
    this.showContentConfiguration = false;
    this.music = false;
    this.conentApproval = !this.conentApproval;
    this.openMusicAddForm = false;
    this.deployments = false;
    this.publisher = false;
    this.Artist = false;
    this.Generes = false;
    this.role = false;
    this.user = false;
  }
  openDeployments() {
    this.pages = [];
    this.totalEntries = 0;
    this.getAllDeployments();
    this.Artist = false;
    this.music = false;
    this.containers = false
    this.Generes = false;
    this.showContentConfiguration = false;
    this.deployments = !this.deployments;
    this.publisher = false;
    this.tags = false;
    this.role = false;
    this.user = false;
  }
  openArtist() {
    this.pages = [];
    this.totalEntries = 0;

    this.Artist = !this.Artist;
    this.Generes = false;
    this.music = false;
    this.containers = false
    this.showContentConfiguration = false;
    this.deployments = false;
    this.publisher = false;
    this.tags = false;
    this.role = false;
    this.user = false;
  }
  openGeneres() {
    this.pages = [];
    this.totalEntries = 0;
    this.getAllGeneres();
    this.Artist = false;
    this.music = false;
    this.containers = false
    this.Generes = !this.Generes;
    this.showContentConfiguration = false;
    this.deployments = false;
    this.publisher = false;
    this.tags = false;
    this.role = false;
    this.user = false;
  }
  // filterPublishers() {
  //   this.filteredPublishers = this.publishers.filter(publisher =>
  //     publisher.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
  //     publisher.email.toLowerCase().includes(this.searchTerm.toLowerCase())
  //   );
  //   this.currentPage = 1;
  //   this.updatePaginatedPublishers();
  // }

  // updatePaginatedPublishers() {
  //   const start = (this.currentPage - 1) * this.pageSize;
  //   const end = start + this.pageSize;
  //   this.paginatedPublishers = this.filteredPublishers.slice(start, end);
  // }

  // onSearchChange(searchValue: any) {
  //   this.searchTerm = searchValue.toLowerCase();
  //   this.filteredCountries = this.countries.filter(country =>
  //     country.name.toLowerCase().includes(this.searchTerm)
  //   );
  // }

  onAddTags() {
    if (this.tagForm.valid) {
      const formData = this.tagForm.value;
      let objJCommmon = {
        id: 0,
        tagName: formData.tagName,
        contentType: formData.contentType
      };
      this.SpinnerService.show();
      if (this.toBeEditedTagId) {
        objJCommmon.id = this.toBeEditedTagId;
        this.authService.updateTag(objJCommmon).subscribe({
          next: (response) => {
            if (response && response.status === 200) {
              this.modalService.dismissAll();
              this.getAllTags();
              this.tagForm.reset();
              this.SpinnerService.hide();
            } else {
              this.SpinnerService.hide();
              console.error("Unexpected response status:", response);
            }
          },
          error: (err) => {
            if (err && err.status == 200) {
              this.modalService.dismissAll();
              this.getAllTags();
              this.tagForm.reset();
              this.SpinnerService.hide();
            }
            console.error("Error adding tag:", err);
            this.SpinnerService.hide();
          }
        });
      } else {
        this.authService.addTag(objJCommmon).subscribe({
          next: (response) => {
            if (response && response.status === 200) {
              this.modalService.dismissAll();
              this.getAllTags();
              this.tagForm.reset();
              this.SpinnerService.hide();
            } else {
              console.error("Unexpected response status:", response);
              this.SpinnerService.hide();
            }
          },
          error: (err) => {
            if (err && err.status == 200) {
              this.modalService.dismissAll();
              this.getAllTags();
              this.tagForm.reset();
              this.SpinnerService.hide();
            }
            console.error("Error adding tag:", err);
            this.SpinnerService.hide();
          }
        });
      }
    } else {
      this.tagForm.markAllAsTouched();
    }
  }

deleteFunc() {
  this.SpinnerService.show();
  if (this.ViewAllText == 'View') {
    let body = { containerId: this.viewAllName.id, itemIds: [this.toBeDeletedId.id] };
    this.authService.deleteTag(this.viewAllName.id, body).subscribe({
      next: (response) => {
        if (response.statusCode == 200) {
          this.modalService.dismissAll();
          this.getViewAll(this.viewAllName.id, this.viewAllName.name);
          this.tosterService.success(this.toBeDeletedText + ' deleted successfully');
        } else {
          this.SpinnerService.hide();
          this.modalService.dismissAll();
          this.tosterService.error(response.message);
        }
      },
      error: (error) => {
        if (error.status == 200) {
          this.modalService.dismissAll();
          this.SpinnerService.hide();
        } else {
          this.SpinnerService.hide();
          this.tosterService.error(error.error.message);
          console.error('Error deleting Record:', error);
        }
      },
    });
  }
  else if(this.ViewAllText == 'playlist' || this.ViewAllText == 'viewallPlaylist'){
     this.deletePlaylists(this.ViewAllText, this.toBeDeletedId);
     this.modalService.dismissAll();
     this.SpinnerService.hide();
  } 
  else if(this.ViewAllText == 'songPlaylIst' ){
     this.deleteSong(this.ViewAllText, this.toBeDeletedId);
     this.modalService.dismissAll();
     this.SpinnerService.hide();
  }
  else if(this.ViewAllText == 'notification' ){
     this.deleteNotification(this.toBeDeletedId)
     this.modalService.dismissAll();
     this.SpinnerService.hide();
  }
  else {
    this.authService.deleteDeployments(this.CarosulesConetnt?.id, this.toBeDeletedId.id).subscribe({
      next: (response) => {
        if (response.statusCode == 200) {
          this.modalService.dismissAll();
          this.getAllRoles(this.CarosulesConetnt?.id);
          this.tosterService.success(this.toBeDeletedText + ' deleted successfully');
        } else {
          this.SpinnerService.hide();
          this.modalService.dismissAll();
          this.tosterService.error(response.error);
        }
       },
       error: (error) => {
        this.tosterService.error(error.error.message);
        this.SpinnerService.hide();
        console.error('Error deleting Record:', error);
       },
     });
   }
 }

  EditTag(obj: any, text: any) {
    this.toBeEditedTagId = obj.id;
    this.laoutForm.patchValue({
      name: obj.title
    });
  }

  onSubmitDeployemnts(): void {
    if (this.deploymentForm.valid) {
      const formData = this.deploymentForm.value;
      let objJCommmon = {
        id: 0,
        serviceName: formData.deploymentName,
      };
      this.SpinnerService.show();
      if (this.toBeEditedTagId) {
        objJCommmon.id = this.toBeEditedTagId;
        this.authService.updateDeployment(objJCommmon).subscribe({
          next: (response) => {
            if (response && response.status === 200) {
              this.modalService.dismissAll();
              this.getAllDeployments();
              this.tosterService.success('Deployment updated successfully');
              this.deploymentForm.reset();
              this.SpinnerService.hide();
            } else {
              this.SpinnerService.hide();
              console.error("Unexpected response status:", response);
            }
          },
          error: (err) => {
            if (err && err.status == 200) {
              this.modalService.dismissAll();
              this.getAllDeployments();
              this.tosterService.success('Deployment updated successfully');
              this.deploymentForm.reset();
              this.SpinnerService.hide();
            }
            console.error("Error adding deployment:", err);
            this.SpinnerService.hide();
          }
        });
      } else {
        this.authService.addDeployment(objJCommmon).subscribe({
          next: (response) => {
            if (response && response.status === 200) {
              this.modalService.dismissAll();
              this.getAllDeployments();
              this.tosterService.success('Deployment added successfully');
              this.deploymentForm.reset();
              this.SpinnerService.hide();
            } else {
              console.error("Unexpected response status:", response);
              this.SpinnerService.hide();
            }
          },
          error: (err) => {
            if (err && err.status == 200) {
              this.modalService.dismissAll();
              this.getAllDeployments();
              this.tosterService.success('Deployment added successfully');
              this.deploymentForm.reset();
              this.SpinnerService.hide();
            }
            console.error("Error adding tag:", err);
            this.SpinnerService.hide();
          }
        });
      }
    } else {
      this.deploymentForm.markAllAsTouched();
    }
  }

  onAddArtist(): void {
    if (this.laoutForm.valid) {
      const formData = this.laoutForm.value;
      this.SpinnerService.show();
      if (this.toBeEditedTagId) {
        let layoutObj = {
          title: formData.name,
        }
        this.authService.updateGenres(this.toBeEditedTagId, layoutObj).subscribe({
          next: (response) => {
            this.modalService.dismissAll();
            this.getAllArtists(this.containersNmae);
            this.tosterService.success('Record updated successfully');
            this.laoutForm.reset();
            this.SpinnerService.hide();
          },
          error: (err) => {
            this.modalService.dismissAll();
            this.getAllArtists(this.containersNmae);
            this.tosterService.success('Record updated successfully');
            this.laoutForm.reset();
            this.SpinnerService.hide();
          }
        });
      }
      this.modalService.dismissAll();
    } else {
      this.laoutForm.markAllAsTouched();
    }
  }
  onAddGenre(): void {
    if (this.genreForm.valid) {
      const formData: any = new FormData();
      formData.append('id', this.toBeEditedTagId ? this.toBeEditedTagId : '0');
      formData.append('categoryName', this.genreForm.get('genreName')?.value);
      const input = document.getElementById('genreImage') as HTMLInputElement;
      if (input && input.files && input.files[0]) {
        formData.append('categoryImage', input.files[0]);
      } else {
        formData.append('categoryImage', '');
      }
      this.SpinnerService.show();
      if (this.toBeEditedTagId) {
        // objJCommmon.id = this.toBeEditedTagId;
        // this.authService.updateGenres(formData).subscribe({
        //   next: (response) => {
        //     if (response && response.status === 200) {
        //       this.modalService.dismissAll();
        //       this.getAllGeneres();
        //       this.tosterService.success('Genre updated successfully');
        //       this.genreForm.reset();
        //       this.SpinnerService.hide();
        //     } else {
        //       this.SpinnerService.hide();
        //       console.error("Unexpected response status:", response);
        //     }
        //   },
        //   error: (err) => {
        //     if (err && err.status == 200) {
        //       this.modalService.dismissAll();
        //       this.getAllGeneres();
        //       this.tosterService.success('Genre updated successfully');
        //       this.genreForm.reset();
        //       this.SpinnerService.hide();
        //     }
        //     console.error("Error adding deployment:", err);
        //     this.SpinnerService.hide();
        //   }
        // });
      } else {
        this.authService.addGenre(formData).subscribe({
          next: (response) => {
            if (response && response.status === 200) {
              this.modalService.dismissAll();
              this.getAllGeneres();
              this.tosterService.success('Genre added successfully');
              this.genreForm.reset();
              this.SpinnerService.hide();
            } else {
              console.error("Unexpected response status:", response);
              this.SpinnerService.hide();
            }
          },
          error: (err) => {
            if (err && err.status == 200) {
              this.modalService.dismissAll();
              this.getAllGeneres();
              this.tosterService.success('Genre added successfully');
              this.genreForm.reset();
              this.SpinnerService.hide();
            }
            console.error("Error adding tag:", err);
            this.SpinnerService.hide();
          }
        });
      }
    } else {
      this.genreForm.markAllAsTouched();
    }
  }

  onAddUser() {
    if (this.userForm.valid) {
      const formData = this.userForm.value;
      let rolesArray = formData.role.map((obj: any) => obj.role);
      let objJCommmon = {
        id: 0,
        email: formData.email,
        username: formData.username,
        contact: formData.contactNumber,
        password: formData.password,
        roles: rolesArray
      }
      this.SpinnerService.show();
      if (this.toBeEditedTagId) {
        objJCommmon.id = this.toBeEditedTagId;
        this.authService.updateUser(objJCommmon).subscribe({
          next: (response) => {
            if (response && response.status === 200) {
              this.modalService.dismissAll();
              this.getAllUsers();
              this.tosterService.success('User updated successfully');
              this.userForm.reset();
              this.SpinnerService.hide();
            } else {
              this.SpinnerService.hide();
              console.error("Unexpected response status:", response);
            }
          },
          error: (err) => {
            if (err && err.status == 200) {
              this.modalService.dismissAll();
              this.getAllUsers();
              this.tosterService.success('User updated successfully');
              this.userForm.reset();
              this.SpinnerService.hide();
            }
            console.error("Error adding deployment:", err);
            this.SpinnerService.hide();
          }
        });
      } else {
        this.authService.addUser(objJCommmon).subscribe({
          next: (response) => {
            if (response && response.status === 200) {
              this.modalService.dismissAll();
              this.getAllUsers();
              this.tosterService.success('User added successfully');
              this.userForm.reset();
              this.SpinnerService.hide();
            } else {
              console.error("Unexpected response status:", response);
              this.SpinnerService.hide();
            }
          },
          error: (err) => {
            if (err && err.status == 200) {
              this.modalService.dismissAll();
              this.getAllUsers();
              this.tosterService.success('User added successfully');
              this.userForm.reset();
              this.SpinnerService.hide();
            }
            console.error("Error adding tag:", err);
            this.SpinnerService.hide();
          }
        });
      }
    } else {
      this.userForm.markAllAsTouched();
    }
  }

  onAddRole() {
    if (this.roleForm.valid) {
      const formData = this.roleForm.value;
      let rolesArray = formData.role.map((obj: any) => obj.role);
      let objJCommmon = {
        id: 0,
        role: rolesArray.join(',')
      }
      this.SpinnerService.show();
      if (this.toBeEditedTagId) {
        objJCommmon.id = this.toBeEditedTagId;
        this.authService.updateRole(objJCommmon).subscribe({
          next: (response) => {
            if (response && response.status === 200) {
              this.modalService.dismissAll();

              this.tosterService.success('Role updated successfully');
              this.roleForm.reset();
              this.SpinnerService.hide();
            } else {
              this.SpinnerService.hide();
              console.error("Unexpected response status:", response);
            }
          },
          error: (err) => {
            if (err && err.status == 200) {
              this.modalService.dismissAll();

              this.tosterService.success('Role updated successfully');
              this.roleForm.reset();
              this.SpinnerService.hide();
            }
            console.error("Error adding deployment:", err);
            this.SpinnerService.hide();
          }
        });
      } else {
        // this.authService.addGenre(objJCommmon).subscribe({
        //   next: (response) => {
        //     if (response && response.status === 200) {
        //       this.modalService.dismissAll();
        //       this.getAllUsers();
        //       this.userForm.reset();
        //       this.SpinnerService.hide();
        //     } else {
        //       console.error("Unexpected response status:", response);
        //       this.SpinnerService.hide();
        //     }
        //   },
        //   error: (err) => {
        //     if (err && err.status == 200) {
        //       this.modalService.dismissAll();
        //       this.getAllUsers();
        //       this.userForm.reset();
        //       this.SpinnerService.hide();
        //     } 
        //     console.error("Error adding tag:", err);
        //     this.SpinnerService.hide();
        //   }
        // });
      }
    } else {
      this.roleForm.markAllAsTouched();
    }
  }

  onAddPublisher() {
    // if (this.publisherForm.valid) {
    //   const formData = this.publisherForm.value;
    //   // let rolesArray = formData.role.map((obj: any) => obj.role);
    //   let objJCommmon = {
    //     id: 0,
    //     email: formData.email,
    //     publisherName: formData.publisherName,
    //     contactPersonName: formData.contactPersonName,
    //     contact: formData.contactNumber,
    //     publisherStatus: formData.publisherStatus ? formData.publisherStatus : 'Active'
    //   }
    //   this.SpinnerService.show();
    //   if (this.toBeEditedTagId) {
    //     objJCommmon.id = this.toBeEditedTagId;
    //     this.authService.updatePublsiher(objJCommmon).subscribe({
    //       next: (response) => {
    //         if (response && response.status === 200) {
    //           this.modalService.dismissAll();
    //           this.getAllPublishers();
    //           this.tosterService.success('Publisher updated successfully');
    //           this.publisherForm.reset();
    //           this.SpinnerService.hide();
    //         } else {
    //           this.SpinnerService.hide();
    //           console.error("Unexpected response status:", response);
    //         }
    //       },
    //       error: (err) => {
    //         if (err && err.status == 200) {
    //           this.modalService.dismissAll();
    //           this.getAllPublishers();
    //           this.tosterService.success('Publisher updated successfully');
    //           this.publisherForm.reset();
    //           this.SpinnerService.hide();
    //         }
    //         console.error("Error adding deployment:", err);
    //         this.SpinnerService.hide();
    //       }
    //     });
    //   } else {
    //     this.authService.addPublisher(objJCommmon).subscribe({
    //       next: (response) => {
    //         if (response && response.status === 200) {
    //           this.modalService.dismissAll();
    //           this.getAllPublishers();
    //           this.tosterService.success('Publisher added successfully');
    //           this.publisherForm.reset();
    //           this.SpinnerService.hide();
    //         } else {
    //           console.error("Unexpected response status:", response);
    //           this.SpinnerService.hide();
    //         }
    //       },
    //       error: (err) => {
    //         if (err && err.status == 200) {
    //           this.modalService.dismissAll();
    //           this.getAllPublishers();
    //           this.tosterService.success('Publisher added successfully');
    //           this.publisherForm.reset();
    //           this.SpinnerService.hide();
    //         }
    //         console.error("Error adding tag:", err);
    //         this.SpinnerService.hide();
    //       }
    //     });
    //   }
    // } else {
    //   this.publisherForm.markAllAsTouched();
    // }
  }

  onAddMusic(): void {
    if (this.musicForm.valid) {
      const formData = this.musicForm.value;
      const uploadData = new FormData();
      uploadData.append('id', this.toBeEditedTagId ? this.toBeEditedTagId.toString() : '0');
      uploadData.append('publisher', formData.publisher);
      uploadData.append('title', formData.name);
      uploadData.append('album', formData.album);
      uploadData.append('artist', formData.artist);
      uploadData.append('featuredArtists', formData.featuredArtist || '');
      uploadData.append('category', formData.genre);
      uploadData.append('language', formData.language ? formData.language : 'English');
      uploadData.append('description', formData.description);
      uploadData.append('shortDescription', formData.shortDescription);
      uploadData.append(
        'eligibleCountries',
        this.selectedCountries == 'Eligible'
          ? formData.eligibleCountires.map((country: any) => country.countryName ? country.countryName : country).join(', ')
          : null
      );
      uploadData.append(
        'restrictedCountries',
        this.selectedCountries == 'Restricted'
          ? formData.restrictedCountries.map((country: any) => country.countryName ? country.countryName : country).join(', ')
          : null
      );
      uploadData.append('tags', formData.tags.map((tag: any) => tag.tagName ? tag.tagName : tag).join(', ') || '');

      if (this.selectedMuiscFile) {
        uploadData.append('musicFile', this.selectedMuiscFile);
      }

      if (this.selectedCrbtFile) {
        uploadData.append('crbtFile', this.selectedCrbtFile);
      }

      if (this.selectedIvrFile) {
        uploadData.append('ivrFile', this.selectedIvrFile);
      }

      if (this.preViewImage) {
        uploadData.append('artwork', this.preViewImage);
      }

      this.SpinnerService.show();

      const apiCall = this.toBeEditedTagId
        ? this.authService.updateMusic(this.toBeEditedTagId, uploadData)
        : this.authService.addMusic(uploadData);

      apiCall.subscribe({
        next: (response) => {
          if (response && response.status === 200) {
            this.modalService.dismissAll();
            this.getAllMusic();
            this.tosterService.success(this.toBeEditedTagId ? 'Music upadted successfully' : 'Music added successfully');
            this.musicForm.reset();
            this.preViewImage = null;
            this.selectedCrbtFile = null;
            this.selectedIvrFile = null;
            this.selectedMuiscFile = null;
            this.openMusicAddForm = false;
            this.music = true;
            this.SpinnerService.hide();
          } else {
            console.error('Unexpected response status:', response);
            this.SpinnerService.hide();
          }
        },
        error: (err) => {
          if (err && err.status === 200) {
            this.modalService.dismissAll();
            this.getAllMusic();
            this.tosterService.success(this.toBeEditedTagId ? 'Record upadted successfully' : 'Record added successfully');
            this.musicForm.reset();
            this.preViewImage = null;
            this.selectedCrbtFile = null;
            this.selectedIvrFile = null;
            this.selectedMuiscFile = null;
            this.openMusicAddForm = false;
            this.music = true;
            this.SpinnerService.hide();
          } else {
            console.error('Error:', err);
            this.SpinnerService.hide();
          }
        },
      });
    } else {
      this.musicForm.markAllAsTouched();
    }
  }


  sortData(column: string, text: string) {
    const arrayMap: { [key: string]: any[] } = {
      Artists: this.artistListedArray,
      Genres: this.genreListedArray,
      Tags: this.tagsArray,
      User: this.userListedArray,
      Role: this.roleArray.song ? this.roleArray.songDetails :
        this.roleArray.tunes ? this.roleArray.callertuneDetails :
         this.roleArray.globalMIX ? this.roleArray.globalPlaylists :
          this.roleArray.artist ? this.roleArray.artistDetails :
            this.roleArray.genre ? this.roleArray.genres :
              '',
      Deployments: this.deploymentListedArray,
      Publisher: this.publisherListedArray,
      Music: this.musicListedArray,
      assign: this.listedListedArray,
      ViewallArray: this.viewAllListedArray,
    };

    const array = arrayMap[text] || [];

    this.sortDirection = this.sortColumn === column
      ? this.sortDirection === 'asc' ? 'desc' : 'asc'
      : 'asc';

    this.sortColumn = column;
    array.sort((a: any, b: any) => {
      const valA = a[column]?.toString().toLowerCase() || '';
      const valB = b[column]?.toString().toLowerCase() || '';
      return this.sortDirection === 'asc'
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    });

    // **Apply sorting & pagination for all categories**
    switch (text) {
      case 'Music':
        this.musicListedArray = [...array];
        this.tabMusicArray = [...array];
        this.filteredMusicArray = [...this.musicListedArray];
        this.totalEntries = this.musicListedArray.length;
        this.setRecordsPerPage(10, this.musicListedArray, 'Music', '');
        this.musicArray = this.updateDisplayedRecords(this.musicListedArray, 'Music', '');
        break;

      case 'Artists':
        this.artistListedArray = [...array];
        this.filteredArtistArray = [...array];
        this.totalEntries = this.artistListedArray.length;
        this.setRecordsPerPage(10, this.artistListedArray, 'Artist', '');
        this.artistArray = this.updateDisplayedRecords(this.artistListedArray, 'Artist', '');
        break;

      case 'assign':
        this.listedListedArray = [...array];
        this.filteredListArray = [...array];
        this.totalEntries = this.listedListedArray.length;
        this.setRecordsPerPage(10, this.listedListedArray, 'assign', '');
        this.ListArray = this.updateDisplayedRecords(this.listedListedArray, 'assign', '');
        break;

      case 'ViewallArray':
        this.viewAllListedArray = [...array];
        this.filteredViewAllArray = [...array];
        this.totalEntries = this.viewAllListedArray.length;
        this.setRecordsPerPage(10, this.viewAllListedArray, 'ViewallArray', '');
        this.viewAllArray = this.updateDisplayedRecords(this.viewAllListedArray, 'ViewallArray', '');
        break;

      case 'Genres':
        this.genreListedArray = [...array];
        this.filteredGeneresArray = [...array];
        this.totalEntries = this.genreListedArray.length;
        this.setRecordsPerPage(10, this.genreListedArray, 'Genre', '');
        this.genreArray = this.updateDisplayedRecords(this.genreListedArray, 'Genre', '');
        break;

      case 'Tags':
        this.tagsListingForm = [...array];
        this.filteredTgasArray = [...array];
        this.totalEntries = this.tagsListingForm.length;
        this.setRecordsPerPage(10, this.tagsListingForm, 'Tag', '');
        this.tagsArray = this.updateDisplayedRecords(this.tagsListingForm, 'Tag', '');
        break;

      case 'User':
        this.userListedArray = [...array];
        this.filteredUserArray = [...array];
        this.totalEntries = this.userListedArray.length;
        this.setRecordsPerPage(10, this.userListedArray, 'User', '');
        this.userArray = this.updateDisplayedRecords(this.userListedArray, 'User', '');
        break;

      case 'Role':
        this.filteredRoleArray = this.roleListedArray = [...array];
        this.totalEntries = array.length;
        this.setRecordsPerPage(10, array, 'Role', '');
        let roleArray = this.updateDisplayedRecords(array, 'Role', '');
        if (this.roleArray.song) this.roleArray.songDetails = this.roleArray.callertuneDetails = roleArray ?? [];
        else if (this.roleArray.genre) this.roleArray.genres = roleArray;
        else if (this.roleArray.artist) this.roleArray.artistDetails = roleArray;
        else if (this.roleArray.globalMIX) this.roleArray.globalPlaylists = roleArray;
        break;

      case 'Deployments':
        this.deploymentListedArray = [...array];
        this.filteredDeployementArray = [...array];
        this.totalEntries = this.deploymentListedArray.length;
        this.setRecordsPerPage(10, this.deploymentListedArray, 'Deployment', '');
        this.deploymentsArray = this.updateDisplayedRecords(this.deploymentListedArray, 'Deployment', '');
        break;

      case 'Publisher':
        this.publisherListedArray = [...array];
        this.filteredPublisherArray = [...array];
        this.totalEntries = this.publisherListedArray.length;
        this.setRecordsPerPage(10, this.publisherListedArray, 'Publisher', '');
        this.publisherArray = this.updateDisplayedRecords(this.publisherListedArray, 'Publisher', '');
        break;
    }

    this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
    this.generatePages();
  }


  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  onStatusChange(event: any, publisher: any) {
    // publisher.publisherStatus = event.target.checked ? 'Active' : 'Inactive';
    // let objJCommmon = {
    //   id: publisher.id,
    //   email: publisher.email,
    //   publisherName: publisher.publisherName,
    //   contactPersonName: publisher.contactPersonName,
    //   contact: publisher.contact,
    //   publisherStatus: publisher.publisherStatus
    // }
    this.SpinnerService.show();
    this.authService.updatePublsiher(event.target.checked, publisher.id).subscribe({
      next: (response) => {
        if (response && response.status === 200) {
          this.getAllArtists(this.storedName);
          this.tosterService.success('Status change successfully');
          this.SpinnerService.hide();
        } else {
          this.getAllArtists(this.storedName);
          this.tosterService.success('Status change successfully');
          this.SpinnerService.hide();
          console.error("Unexpected response status:", response);
        }
      },
      error: (err) => {
        if (err && err.status == 200) {
          this.getAllArtists(this.storedName);
          this.tosterService.success('Status change successfully');
          this.SpinnerService.hide();
        }
        console.error("Error adding deployment:", err);
        this.SpinnerService.hide();
      }
    });
  }

  updatePageSize(event: Event, text: string): void {
    const target = event.target as HTMLSelectElement;
    const newPageSize = +target.value;
    this.recordsPerPage = newPageSize;
    this.pageSize = newPageSize;

    const arrayMap: { [key: string]: any[] } = {
      Music: this.filteredMusicArray,
      Deployment: this.filteredDeployementArray,
      Artist: this.filteredArtistArray,
      Role: this.filteredRoleArray,
      ViewallArray: this.filteredViewAllArray,
      assign: this.filteredListArray,
      Genre: this.filteredGeneresArray,
      User: this.filteredUserArray,
      Tag: this.tagsArray,
      Publisher: this.filteredPublisherArray
    };

    const array = arrayMap[text] || [];
    this.totalPages = Math.ceil(array.length / this.recordsPerPage);
    this.currentPage = 1;
    this.updateDisplayedRecords(array, text, '');
    this.generatePages();
  }

  updateDisplayedRecords(array: any, text: string, str: string): any[] {
    const startIndex = (this.currentPage - 1) * this.recordsPerPage;
    const endIndex = startIndex + this.recordsPerPage;
    switch (text) {
      case 'Music':
        this.musicArray = [];
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex)
          : (str == 'filter_apply') ? array.slice(startIndex, endIndex)
            : this.tabMusicArray.length ? this.tabMusicArray.slice(startIndex, endIndex)
              : this.filteredMusicArray.slice(startIndex, endIndex);
        this.musicArray = array;
        break;
      case 'HiddenSongs':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex)
          : (str == 'filter_apply') ? array.slice(startIndex, endIndex)
            : this.tabMusicArray.length ? this.tabMusicArray.slice(startIndex, endIndex)
              : this.filteredHiddenSongsArray.slice(startIndex, endIndex);
        this.hiddenSongsArray = array;
        break;
      case 'Deployment':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredDeployementArray.slice(startIndex, endIndex);
        this.deploymentsArray = array;
        break;
      case 'newRole':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredListArray.slice(startIndex, endIndex);
        this.ListArray = array;
        break;
      case 'ViewallArray':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredViewAllArray.slice(startIndex, endIndex);
        this.viewAllArray = array;
        break;
      case 'Country':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredCountryArray.slice(startIndex, endIndex);
        this.countryArray = [];
        this.countryArray = array;
        break;
      case 'assign':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredListArray.slice(startIndex, endIndex);
        this.ListArray = [];
        this.ListArray = array;
        break;
      case 'Artist':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredArtistArray.slice(startIndex, endIndex);
        this.artistArray = array;
        break;
      case 'Role':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredRoleArray.slice(startIndex, endIndex);
        if (this.roleArray.song) {
          this.roleArray.songDetails = [];
          this.roleArray.songDetails = array;
          this.roleArray.song = true;
          this.roleArray.genre = false;
          this.roleArray.artist = false;
          this.roleArray.tunes = false;
          this.roleArray.globalMIX = false;
        }
        if (this.roleArray.tunes) {
          this.roleArray.callertuneDetails = [];
          this.roleArray.callertuneDetails = array;
          this.roleArray.song = false;
          this.roleArray.genre = false;
          this.roleArray.artist = false;
          this.roleArray.globalMIX = false;
          this.roleArray.tunes = true;
        }
        if (this.roleArray.globalMIX) {
          this.roleArray.globalPlaylists = [];
          this.roleArray.globalPlaylists = array;
          this.roleArray.song = false;
          this.roleArray.genre = false;
          this.roleArray.artist = false;
          this.roleArray.globalMIX = true;
          this.roleArray.tunes = false;
        }
        if (this.roleArray.genre) {
          // let arary = array.genres;
          this.roleArray = [];
          // this.roleArray.artistDetails = arary;
          // this.roleArray.songDetails = array;
          this.roleArray.genres = array;
          this.roleArray.song = false;
          this.roleArray.genre = true;
          this.roleArray.artist = false;
          this.roleArray.globalMIX = false;
          this.roleArray.tunes = false;
        }
        if (this.roleArray.artist) {
          // let arary = array.genres;
          this.roleArray = [];
          // this.roleArray.artistDetails = arary;
          // this.roleArray.songDetails = array;
          // this.roleArray.genres = arary;
          this.roleArray.artistDetails = array;
          this.roleArray.song = false;
          this.roleArray.genre = false;
          this.roleArray.artist = true;
          this.roleArray.globalMIX = false;
          this.roleArray.tunes = false;
        }
        break;
      case 'User':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredUserArray.slice(startIndex, endIndex);
        this.userArray = array;
        break;
      case 'Genre':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredGeneresArray.slice(startIndex, endIndex);
        this.genreArray = array;
        break;
      case 'Tag':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.tagsArray.slice(startIndex, endIndex);
        this.tagsArray = array;
        break;
      case 'Publisher':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredPublisherArray.slice(startIndex, endIndex);
        this.publisherArray = array;
        break;
      default:
        array = [];
        break;
    }

    return array;
  }

  get startEntry(): number {
    return this.totalEntries === 0 ? 0 : (this.currentPage - 1) * this.recordsPerPage + 1;
  }

  get endEntry(): number {
    const end = this.currentPage * this.recordsPerPage;
    return Math.min(end, this.totalEntries);
  }

  onRecordsPerPageChange(event: any, array: any) {
    this.pageSize = +event.target.value;
    this.getPaginatedData(array);
  }

  getPaginatedData(array: any) {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.userArray = array.slice(startIndex, endIndex);
  }

  goToPage(page: any, array: any[], text: any) {
    if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
      this.currentPage = page;
      if (text === 'notification') {
        this.getAllManageNotification(page - 1);
      } else {
        this.updateDisplayedRecords(array, text, '');
        this.generatePages();
      }
    }
  }

  previousPage(array: any[], text: any) {
    if (this.currentPage > 1) {
      this.currentPage--;
      if (text === 'notification') {
        this.getAllManageNotification(this.currentPage - 1);  // convert back to 0-based
      } else {
        this.updateDisplayedRecords(array, text, '');
        this.generatePages();
      }
    }
  }

  nextPage(array: any[], text: any) {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      if (text === 'notification') {
        this.getAllManageNotification(this.currentPage - 1);
      } else {
        this.updateDisplayedRecords(array, text, '');
        this.generatePages();
      }
    }
  }

  setRecordsPerPage(recordsPerPage: number, array: any[], text: any, value: any) {
    this.recordsPerPage = recordsPerPage;
    this.totalEntries = array.length;
    this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
    this.currentPage = 1;
    this.updateDisplayedRecords(array, text, value);
    this.generatePages();
  }

  generatePages() {
    const pagesArray: (number | string)[] = [];
    const maxPagesToShow = 5;
    const halfRange = Math.floor(maxPagesToShow / 2);

    if (this.totalPages <= maxPagesToShow) {
      for (let i = 1; i <= this.totalPages; i++) {
        pagesArray.push(i);
      }
    } else {
      if (this.currentPage <= halfRange + 1) {
        for (let i = 1; i < maxPagesToShow; i++) {
          pagesArray.push(i);
        }
        pagesArray.push('...');
        pagesArray.push(this.totalPages);
      } else if (this.currentPage > this.totalPages - halfRange) {
        pagesArray.push(1);
        pagesArray.push('...');
        for (let i = this.totalPages - (maxPagesToShow - 2); i <= this.totalPages; i++) {
          pagesArray.push(i);
        }
      } else {
        pagesArray.push(1);
        pagesArray.push('...');
        for (let i = this.currentPage - halfRange; i <= this.currentPage + halfRange; i++) {
          pagesArray.push(i);
        }
        pagesArray.push('...');
        pagesArray.push(this.totalPages);
      }
    }
    // Ensure the last page appears only once
    const lastPage = pagesArray[pagesArray.length - 2];
    if (lastPage === '...' && pagesArray[pagesArray.length - 3] === this.totalPages) {
      pagesArray.pop(); // Remove the duplicate last page
    }

    this.pages = pagesArray;
  }

  selectCountry(country: string): void {
    this.selectedCountries = country;
  }

  onMusicFileSelected(event: any): void {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files?.[0] ?? null;
    this.selectedMuiscFile = file;
    if (file) {
      const fileExtension = this.getFileExtension(file.name);
      if (fileExtension === 'mp3') {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.musicFileUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        alert('Please select a valid MP3 file.');
        fileInput.value = '';
        this.musicFileUrl = null;
      }
    }
  }

  onAudioFileSelected(event: any, fileType: string): void {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files?.[0];
    if (file) {
      const fileExtension = this.getFileExtension(file.name);
      if (fileExtension === 'wav') {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          if (fileType === 'crbt') {
            this.selectedCrbtFile = file;
            this.crbtFileUrl = e.target.result;
          } else if (fileType === 'ivr') {
            this.selectedIvrFile = file;
            this.ivrFileUrl = e.target.result;
          }
        };
        reader.readAsDataURL(file);
      } else {
        alert('Please select a valid WAV file.');
        fileInput.value = '';
        if (fileType === 'crbt') {
          this.crbtFileUrl = null;
        } else if (fileType === 'ivr') {
          this.ivrFileUrl = null;
        }
      }
    }
  }

  previewImageFile(event: any): void {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files?.[0] ?? null;
    this.preViewImage = file;
    if (file) {
      const fileExtension = this.getFileExtension(file.name);
      if (fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg') {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.previewImageUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        alert('Please select a valid PNG or JPG image.');
        fileInput.value = '';
        this.previewImageUrl = null;
      }
    }
  }

  private getFileExtension(fileName: string): string {
    return fileName.split('.').pop()?.toLowerCase() || '';
  }

  onCheckboxChange(event: any): void {
    this.selectAll = event.target.checked;
    this.filteredMusicArray.forEach((publisher: any) => {
      if(publisher.status){
        publisher.checked = this.selectAll;
      }
    });
  }
  onCheckboxGenereArrayChange(event: any): void {
    this.selectAll = event.target.checked;
    this.filteredListArray.forEach((publisher: any) => {
      publisher.checked = this.selectAll;
    });
  }
  onResetFilters() {
    this.SpinnerService.show();
    this.filterForm.reset({
      publisher: null,
      artist: null,
      startDate: null,
      endDate: null
    });
    const { publisher, artist, startDate, endDate } = this.filterForm.value;
    const start = startDate ? new Date(startDate) : null;
    if (start) start.setHours(0, 0, 0, 0);
    const end = endDate ? new Date(endDate) : null;
    if (end) end.setHours(23, 59, 59, 999);
    this.musicArray = this.filteredMusicArray.filter((item: any) => {
      const itemDate = this.parseDate(item?.dateAdded ? item?.dateAdded : item?.releaseDate);
      const matchPublisher = publisher ? item.publisher.trim('') === publisher : true;
      const matchArtist = artist ? item.artists === artist : true;
      const matchStartDate = start ? itemDate >= start : true;
      const matchEndDate = end ? itemDate <= end : true;
      return matchPublisher && matchArtist && matchStartDate && matchEndDate;
    });
    if (!publisher && !artist && !startDate && !endDate) {
      this.musicArray = [...this.musicListedArray];
    }
    this.initializeMusicArray();
    this.SpinnerService.hide();
    this.pageSize = 10;
  }
  musicListedArray: any = [];
  onFilterMuisc() {
    this.SpinnerService.show();
    const { publisher, artist, startDate, endDate } = this.filterForm.value;
    if (this.musicArray.length == 0 && (publisher || artist || (startDate && endDate))) {
      this.filteredMusicArray = [...this.musicListedArray];
    }
    const start = startDate ? new Date(startDate) : null;
    if (start) start.setHours(0, 0, 0, 0);
    const end = endDate ? new Date(endDate) : null;
    if (end) end.setHours(23, 59, 59, 999);
    this.musicArray = this.filteredMusicArray.filter((item: any) => {
      const itemDate = this.parseDate(item?.dateAdded ? item?.dateAdded : item?.releaseDate);
      const matchPublisher = publisher ? item.publisher.trim('') === publisher : true;
      const matchArtist = artist ? item.artists === artist : true;
      const matchStartDate = start ? itemDate >= start : true;
      const matchEndDate = end ? itemDate <= end : true;
      return matchPublisher && matchArtist && matchStartDate && matchEndDate;
    });
    if (!publisher && !artist && !startDate && !endDate) {
      this.musicArray = [...this.musicListedArray];
    }
    this.initializeMusicArray();
    this.SpinnerService.hide();
    this.pageSize = 10;
  }

  parseDate(dateString: string): Date {
    const [day, month, year] = dateString?.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  async fetchMusicDetails(mD: any) {
    this.SpinnerService.show();
    try {
      const publisher = {
        musicId: mD.id,
        name: mD.title,
        artist: mD.artist,
        tags: mD.tags,
        type: mD.type,
        deployedOn: mD.deployedOn,
        status: mD.status,
      };
      const excelData = [
        ["Music ID", "Name", "Artist", "Tags", "Type", "Deployed On", "Status"],
        Object.values(publisher),
      ];
      const ws = XLSX.utils.aoa_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Music Details");
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

      const zip = new JSZip();
      zip.file("MusicDetails.xlsx", excelBuffer);
      const fetchBinaryData = async (url: string): Promise<Uint8Array> => {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to fetch resource: ${url}`);
        }
        const arrayBuffer = await response.arrayBuffer();
        return new Uint8Array(arrayBuffer);
      };

      for (const resource of mD.releaseResources) {
        const { downloadUrl, fileTypeId } = resource;
        let fileName = "";
        switch (fileTypeId) {
          case 4:
            fileName = "Image.jpg";
            break;
          case 1:
            fileName = "Music.mp3";
            break;
          case 2:
            fileName = "CRBT.wav";
            break;
          case 3:
            fileName = "IVR.wav";
            break;
          default:
            console.warn(`Unknown file type: ${fileTypeId}, skipping resource.`);
            continue;
        }

        try {
          console.log(`Attempting to fetch and add file: ${fileName} from URL: ${downloadUrl}`);
          const fileData = await fetchBinaryData('https://' + downloadUrl);
          zip.file(fileName, fileData);
          console.log(`Successfully added file: ${fileName} to ZIP.`);
        } catch (error) {
          console.error(`Skipping resource due to error: ${downloadUrl}`, error);
        }
      }
      zip.generateAsync({ type: "blob" })
        .then((content) => {
          console.log("ZIP file generated successfully, now you can download or use the content.");
          saveAs(content, "Music_Data.zip");
        })
        .catch((err) => console.error("Error generating ZIP file:", err));
      this.SpinnerService.hide();

    } catch (error) {
      console.error("Error in fetchMusicDetails:", error);
      this.SpinnerService.hide();
    }
  }

  // toggleCountry(type: string, event: Event) {
  //   const isChecked = (event.target as HTMLInputElement).checked;
  //   if (isChecked) {
  //     if (!this.selectedCountries.includes(type)) {
  //       this.selectedCountries.push(type);
  //     }
  //   } else {
  //     this.selectedCountries = this.selectedCountries.filter(country => country !== type);
  //   }
  // }

  chnageMuiscStatus(text: any, obj: any) {
    this.statusChangeText = text;
    this.statusChangeMuiscDetails = obj;
  }

  onMuiscStatusChange() {
    const approvalStatusMap: any = { Reject: 5, Approve: 3, Deploy: 2 };
    const approvalMessages: any = {
      Reject: 'Music rejected successfully',
      Approve: 'Music approved successfully',
      Deploy: 'Music deployed successfully',
    };

    const releaseIdArray = [this.statusChangeMuiscDetails.id];
    const releaseId = this.statusChangeMuiscDetails.id;
    const approvalStatusId = approvalStatusMap[this.statusChangeText] || 0;
    const onStatusChangeObj = { releaseId, approvalStatusId };
    if (this.statusChangeText === 'Deploy') {
      this.authService.onDeployMusicListing({ releaseId: releaseIdArray }).subscribe({
        next: () => this.closeModal(),
        error: (error) => this.handleError(error),
      });
    }
    this.authService.onChangeMusicStatus(onStatusChangeObj).subscribe({
      next: () => {
        this.SpinnerService.hide();
        this.getAllMusic();
        this.selectedTab = 'All';
        this.tosterService.success(approvalMessages[this.statusChangeText] || '');
        this.closeModal();
      },
      error: (error) => {
        // this.handleError(error);
        this.SpinnerService.hide();
        this.getAllMusic();
        this.selectedTab = 'All';
        this.tosterService.success(approvalMessages[this.statusChangeText] || '');
        this.closeModal();
      }
    });
  }

  closeModal() {
    this.SpinnerService.hide();
    this.modalService.dismissAll();
  }

  handleError(error: any) {
    this.SpinnerService.hide();
    console.error(error);
  }

  logout() {
    const token = localStorage.getItem('token');
    if (token && token !== 'undefined' && token !== 'null') {
      this.SpinnerService.show();
      this.authService.logout(token).subscribe(
        (response) => {
          this.SpinnerService.hide();
          localStorage.removeItem('token');
          localStorage.removeItem('username');
          sessionStorage.removeItem('token');
          this.router.navigate(['/login']);
          this.tosterService.success('Logout successfully');
          this.modalService.dismissAll();
        },
        (error) => {
          this.SpinnerService.hide();
          localStorage.removeItem('token');
          sessionStorage.removeItem('token');
          this.router.navigate(['/login']);
          this.tosterService.success('Logout successfully');
          this.modalService.dismissAll();
          console.error(error);
        }
      );
    }
  }

  togglePasswordVisibilitys(field: string) {
    switch (field) {
      case 'current':
        this.showCurrentPassword = !this.showCurrentPassword;
        break;
      case 'new':
        this.showNewPassword = !this.showNewPassword;
        break;
      case 'confirm':
        this.showConfirmPassword = !this.showConfirmPassword;
        break;
    }
  }

  get passwordMismatch(): boolean {
    const newPassword = this.passwordForm.get('newPassword')?.value;
    const confirmPassword = this.passwordForm.get('confirmPassword')?.value;
    return newPassword && confirmPassword && newPassword !== confirmPassword;
  }

  chnagePaasword() {
    if (this.passwordForm.valid) {
      if (this.passwordForm.valid && !this.passwordMismatch) {
        let passowrdChange = {
          oldPassword: this.passwordForm.value.currentPassword,
          newPassword: this.passwordForm.value.newPassword,
        }
        this.authService.chnagePassword(passowrdChange).subscribe(
          (response) => {
            if (!response.status) {
              this.SpinnerService.hide();
              this.modalService.dismissAll();
              this.tosterService.error(response.message);
              console.error(response.message);
            } else {
              this.SpinnerService.hide();
              this.modalService.dismissAll();
              this.tosterService.success('Password changed successfully');
            }
          },
          (error) => {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.tosterService.error(error.error.message);
            console.error(error);
          }
        );
      }
    } else {
      this.passwordForm.markAllAsTouched();
    }
  }

  selectAllMuisc() {
    this.selectAll = true;
    this.filteredMusicArray.forEach((publisher: any) => {
      if(publisher.status){
        publisher.checked = true;
      }
    });
    this.tabMusicArray.forEach((publisher: any) => {
      if(publisher.status){
        publisher.checked = true;
      }
    });
    this.musicArray.forEach((publisher: any) => {
      if(publisher.status){
        publisher.checked = true;
      }
    });
  }

  UnselectRecords() {
    this.selectAll = false;
    this.filteredMusicArray.forEach((publisher: any) => {
      publisher.checked = false;
    });
  }

  selectAllRecords() {
    this.selectAll = true;
    this.filteredListArray.forEach((publisher: any) => {
      publisher.checked = true;
    });
  }

  unselectAllRecords() {
    this.selectAll = false;
    this.filteredListArray.forEach((publisher: any) => {
      publisher.checked = false;
    });
  }

  selectALLPlaylistRecords() {
    this.selectAll = true;
    this.filteredViewAllArray.forEach((publisher: any) => {
      publisher.checked = true;
    });
  }

  unselectAllPlahyLIstRecords() {
    this.selectAll = false;
    this.filteredViewAllArray.forEach((publisher: any) => {
      publisher.checked = false;
    });
  }


  onIndividualCheck(publisher: any, text: any) {
    if(publisher.status){
      if (text == 'music') {
        publisher.checked = !publisher.checked;
        const matchedItem = this.filteredMusicArray.find(item => item.id === publisher.id);
        if (matchedItem) {
          matchedItem.checked = publisher.checked;
        }
      }
      else{
        const matchedItem = this.listedListedArray.find(item => item.id === publisher.id);
        if (matchedItem) {
          matchedItem.checked = publisher.checked;
        }
        publisher.checked = !publisher.checked;
      }
    }
  }

  HiddenSongs: boolean = false;
  hiddenSongsArray: any = [];
  SelectTag(model: any, text: any) {
    this.HiddenSongs = true;
    this.music = false;
    // const isAnyChecked = this.musicArray.some((publisher: any) => publisher.checked);
    // if (isAnyChecked) {
    //   this.selectedTax = text;
    //   this.openAddForm(model);
    // } else {
    //   alert('Please select atleast one record');
    // }
  }

  SelectGenre() {
    this.SpinnerService.show();
    const checkedItems = this.listedListedArray.filter((item: any) => item.checked);
    const itemIds = checkedItems.map((item: any) => item.id);

    if (!itemIds.length) {
      this.SpinnerService.hide();
      return alert('Please select at least one record');
    }

    if (this.addContent) {
      this.authService.getAllRoles(this.CarosulesConetnt?.id).subscribe((response1) => {
        if (response1.data.genres) {
          this.authService.getAllArtists(
            this.containersNmae === 'Search tab' ? 'SEARCH' :
              this.containersNmae === 'Callertunes' ? 'CALLER_TUNE' : 'HOME'
          ).subscribe(
            (response) => {
              const consumedData = response.data.find((item: any) => item.id === this.CarosulesConetnt?.id);
              const remainingCapacity = 15 - (consumedData?.consumedCapacity || 0);
              
              const existingSongDetails = Array.isArray(response1.data.genres) ? response1.data.genres : [];
              const existingArtistIds = new Set(existingSongDetails.map((artist: any) => artist.id));
              
              const filteredItems = checkedItems.filter((item: any) => !existingArtistIds.has(item.id));
              const selectedItems = filteredItems.slice(0, remainingCapacity);
              
              const selectedMapped = selectedItems.map((item, index) => ({
                itemId: item.id,
                sequence: index
              }));
              
              const existingMapped = existingSongDetails.map((item: { id: any; }, index: number) => ({
                itemId: item.id,
                sequence: selectedMapped.length + index
              }));
              
              this.itemsArray = [...selectedMapped, ...existingMapped];
              
              this.searchTerm = '';
              this.moveToCarasoluesContent(this.CarosulesConetnt);
              setTimeout(() => {
                this.tosterService.success('Genre assigned successfully');
              }, 3000);
            },
            (error) => {
              this.SpinnerService.hide();
              console.error(error);
            }
          );
        }
      });
    } else {
      const obj = {
        containerId: this.assignSongsToParticularObj.id,
        itemIds: itemIds
      };

      this.authService.addDeployment(obj).subscribe(
        () => {
          // Success callback
          this.moveToViewALLContent(this.assignSongsToParticularObj);
          setTimeout(() => {
            this.tosterService.success('Genre assigned successfully');
          }, 3000);
        },
        (error) => {
          // Error callback
          this.SpinnerService.hide();
          this.tosterService.error(error.error.message);
          console.error(error);
        }
      );

    }
    this.searchTerm = '';
  }

  SelectMUsic() {
  this.SpinnerService.show();
  const checkedItems = [
    ...this.musicListedArray.filter((p: any) => p.checked),
    ...this.filteredViewAllArray.filter((p: any) => p.checked)
  ];

  if (!checkedItems.length) {
    this.SpinnerService.hide();
    return alert('Please select at least one record');
  }

  const showSuccess = () => {
    setTimeout(() => {
      this.tosterService.success(this.containersNmae === 'Callertunes'
        ? 'Callertune assigned successfully'
        : this.CarosulesConetnt.name == "GLOBAL_MIX" ? 'Playlist assigned successfully'
        : 'Song assigned successfully'
      );
    }, 2000);
    this.searchTerm = ''
  };

  const processSelection = (existingSongDetails: any[], response: any) => {
    const consumedData = response.data.find((item: any) => item.id === this.CarosulesConetnt?.id);
    const remainingCapacity = 15 - (consumedData?.consumedCapacity || 0);

    const existingIds = new Set(existingSongDetails.map((a: any) => a.id));
    const filteredItems = checkedItems.filter((i: any) => !existingIds.has(i.id));
    const selectedItems = filteredItems.slice(0, remainingCapacity);

    const selectedMapped = selectedItems.map((item, idx) => ({ itemId: item.id, sequence: idx }));
    const existingMapped = existingSongDetails.map((item, idx) => ({
      itemId: item.id,
      sequence: selectedMapped.length + idx
    }));

    this.itemsArray = [...selectedMapped, ...existingMapped];
    this.searchTerm = '';
    this.moveToCarasoluesContent(this.CarosulesConetnt);
    showSuccess();
  };

  if (this.addContent) {
    this.authService.getAllRoles(this.CarosulesConetnt?.id).subscribe((response1) => {
      const data = response1.data;
      const existing =
        data.songDetails || data.globalPlaylists || data.callertuneDetails || [];

      this.authService.getAllArtists(
        this.containersNmae == 'Search tab' ? 'SEARCH' :
        this.containersNmae == 'Callertunes' ? 'CALLER_TUNE' : 'HOME'
      ).subscribe(
        (response) => processSelection(existing, response),
        (error) => {
          this.SpinnerService.hide();
          console.error(error);
        }
      );
    });
  } else {
    const ids = checkedItems.map((i: any) => i.id);

    if (this.manageContent.name == 'GLOBAL_MIX') {
      this.authService.AddPlayList({
        globalPlaylistId: this.assignSongsToParticularObj.id,
        songsIds: ids
      }).subscribe(
        () => {
          this.moveToAssignSongs(this.manageContent, '');
          showSuccess();
        },
        (error) => {
          this.SpinnerService.hide();
          this.tosterService.error(error.error.message);
        }
      );
    } else {
      this.authService.addDeployment({
        containerId: this.assignSongsToParticularObj.id,
        itemIds: ids
      }).subscribe(
        () => {
          this.moveToViewALLContent(this.assignSongsToParticularObj);
          showSuccess();
        },
        (error) => {
          this.SpinnerService.hide();
          this.tosterService.error(error.error.message);
        }
      );
    }
  }
}

  SelectArtist() {
    this.SpinnerService.show();
    const checkedItems = this.listedListedArray.filter((publisher: any) => publisher.checked);
    const itemIds = checkedItems.map((item: any) => item.id);
    if (!itemIds.length) {
      return alert('Please select at least one record');
    }
    if (this.addContent) {
      this.authService.getAllRoles(this.CarosulesConetnt?.id).subscribe((response1) => {
        if (response1.data.artistDetails) {
          this.authService.getAllArtists(
            this.containersNmae === 'Search tab' ? 'SEARCH' :
              this.containersNmae === 'Callertunes' ? 'CALLER_TUNE' : 'HOME'
          ).subscribe(
            (response) => {
              const consumedData = response.data.find((item: any) => item.id === this.CarosulesConetnt?.id);
              const remainingCapacity = 15 - (consumedData?.consumedCapacity || 0);
              
              const existingSongDetails = Array.isArray(response1.data.artistDetails) ? response1.data.artistDetails : [];
              const existingArtistIds = new Set(existingSongDetails.map((artist: any) => artist.id));
              
              const filteredItems = checkedItems.filter((item: any) => !existingArtistIds.has(item.id));
              const selectedItems = filteredItems.slice(0, remainingCapacity);
              
              const selectedMapped = selectedItems.map((item, index) => ({
                itemId: item.id,
                sequence: index
              }));
              
              const existingMapped = existingSongDetails.map((item: { id: any; }, index: number) => ({
                itemId: item.id,
                sequence: selectedMapped.length + index
              }));
              
              this.itemsArray = [...selectedMapped, ...existingMapped];
              
              this.searchTerm = '';
              this.moveToCarasoluesContent(this.CarosulesConetnt);
              setTimeout(() => {
                this.tosterService.success('Artist assigned successfully');
              }, 3000);
            },
            (error) => {
              this.SpinnerService.hide();
              console.error(error);
            }
          );
        }
      });
      // this.moveToCarasoluesContent(this.CarosulesConetnt);
      // this.tosterService.success('Artist assigned successfully');
    }
    else {
      let obj = {
        containerId: this.assignSongsToParticularObj.id,
        itemIds: itemIds
      };

      this.authService.addDeployment(obj).subscribe(
        (response) => {
          this.moveToViewALLContent(this.assignSongsToParticularObj);
          setTimeout(() => {
            this.tosterService.success('Artist assigned successfully');
          }, 3000);
        },
        (error) => {
          this.SpinnerService.hide();
          this.tosterService.error(error.error.message);
          console.error(error);
        }
      );
    }
    this.searchTerm = '';
  }

  backToMusicList() {
    this.getAllMusic();
    this.HiddenSongs = false;
    this.music = true;
  }

  RemoveTag(model: any, text: any) {
    this.SpinnerService.show();
    let array: any[] = [];

    // Fetch data for both roles
    Promise.all([
      this.authService.getAllRoles(4).toPromise(),
      this.authService.getAllRoles(9).toPromise()
    ])
      .then(([response1, response2]) => {
        // Combine song details from both responses
        array = [
          ...(response1?.data?.songDetails || []),
          ...(response2?.data?.songDetails || [])
        ];

        // Find checked items
        const checkedItems = this.filteredMusicArray.filter((publisher: any) => publisher.checked);

        // Check for conflicting songs
        const conflictingItems = checkedItems.filter((item: any) =>
          array.some((song: any) => song.id === item.id)
        );

        if (conflictingItems.length > 0) {
          this.SpinnerService.hide();

          // Generate a single alert message
          const conflictingIds = conflictingItems.map((item: any) => item.id);
          const message = conflictingIds.length === 1
            ? `Remove the song with ID: ${conflictingIds[0]} from the carousel before proceeding.`
            : `Remove songs with IDs: ${conflictingIds.join(', ')} from the carousel before proceeding.`;

          alert(message);
          return;
        }

        if (checkedItems.length > 0) {
          let successCount = 0;
          let failedIds: number[] = []; // Store failed song IDs

          let requestsCompleted = 0; // Track completed requests

          checkedItems.forEach((item: any) => {
            this.authService.HideSongs(item.id).subscribe(
              (response) => {
                if (!response.status) {
                  failedIds.push(item.id);
                } else {
                  successCount++;
                }

                requestsCompleted++;
                if (requestsCompleted === checkedItems.length) {
                  this.finalizeHideSongsProcess(successCount, failedIds);
                }
              },
              (error) => {
                failedIds.push(item.id);
                requestsCompleted++;
                if (requestsCompleted === checkedItems.length) {
                  this.finalizeHideSongsProcess(successCount, failedIds);
                }
              }
            );
          });
        } else {
          this.SpinnerService.hide();
          alert('Please select at least one record.');
        }
      })
      .catch((error) => {
        console.error('Error fetching roles:', error);
        this.SpinnerService.hide();
        this.tosterService.error('Failed to fetch roles.');
      });
  }

  private finalizeHideSongsProcess(successCount: number, failedIds: number[]) {
    this.modalService.dismissAll();
    this.getAllMusic();
    this.selectAll = false;
    if (failedIds.length > 0) {
      this.SpinnerService.hide();
      this.tosterService.error(
        `Failed to hide songs for the selected IDs, Please try again !`
      );
    }

    if (successCount > 0 && failedIds.length === 0) {
      this.tosterService.success('Songs hidden successfully for all selected IDs');
    }
  }

  onUpdateTagsStatus(status: boolean) {
    if (this.tagsListingForm.valid) {
      const checkedIds = this.musicArray
        .filter((publisher: any) => publisher.checked)
        .map((publisher: any) => publisher.id);
      const tagNamesArray = this.tagsListingForm.value.tags.map((tag: any) => tag.tagName);

      checkedIds.forEach((id: any) => {
        const tagsObj = {
          releaseId: id,
          tags: tagNamesArray,
          isDelete: status,
        };
        this.authService.UpadteTagsStatus(tagsObj).subscribe(
          (response) => {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.getAllMusic();
            this.tosterService.success(`Tags ${status ? 'removed' : 'added'} successfully for ID: ${id}`);
          },
          (error) => {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.getAllMusic();
            this.tosterService.error(`Failed to ${status ? 'removed' : 'added'} tags for ID: ${id}`);
            console.error(error);
          }
        );
      });
    } else {
      this.tagsListingForm.markAllAsTouched();
    }
  }

  openMusicForm() {
    this.openMusicAddForm = true;
    this.musicForm.reset();
    this.music = false;
    this.preViewImage = null;
    this.previewImageUrl = null;
    this.crbtFileUrl = null;
    this.selectedCrbtFile = null;
    this.selectedMuiscFile = null;
    this.selectedIvrFile = null;
    this.ivrFileUrl = null;
    this.musicFileUrl = null;
    this.selectedCountries = 'Eligible';
  }

  moveToContainers(name: any) {
    this.pages = [];
    this.totalEntries = 0;
    this.getAllArtists(name);
    this.containersNmae = name;
    this.Artist = !this.Artist;
    this.Generes = false;
    this.music = false;
    this.containers = false
    this.conentApproval = false;
    this.showContentConfiguration = false;
    this.deployments = false;
    this.publisher = false;
    this.tags = false;
    this.role = false;
    this.user = false;
  }

  onPlaylIstFileSelected(event: any) {
  const fileInput = event.target as HTMLInputElement;
  const file = fileInput.files?.[0];
  if (!file) return;

  // Validate size
  if (file.size > 20 * 1024) {
    this.imageError = 'File size exceeds 20KB.';
    this.playlistForm.patchValue({ playlistImage: null });
    fileInput.value = ''; // clear input box
    return;
  }

  // ✅ Allow JPG, PNG, and WebP formats
  if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
    this.imageError = 'Only JPG, PNG, and WebP formats are allowed.';
    this.playlistForm.patchValue({ playlistImage: null });
    fileInput.value = ''; // clear input box
    return;
  }

  // Validate dimensions
  const img = new Image();
  img.onload = () => {
    if (img.width !== 300 || img.height !== 200) {
      this.imageError = 'Image must be 300×200 px.';
      this.playlistForm.patchValue({ playlistImage: null });
      fileInput.value = ''; // clear input box
    } else {
      this.imageError = null;
      this.playlistForm.patchValue({ playlistImage: file });
    }
  };
  img.src = URL.createObjectURL(file);
}


onSubmitPlayLIstForm() {
  this.SpinnerService.show();
  if (this.playlistForm.valid) {
    const formData = new FormData();
    formData.append('playlistName', this.playlistForm.get('playlistName')?.value);
    formData.append('image', this.playlistForm.get('playlistImage')?.value);

    if (this.formMode === 'add') {
      // Add API
      this.authService.CreatePlayList(formData).subscribe({
        next: (res) => {
          this.moveToAssignSongs(this.assignSongsToParticularObj, '');
          this.deployments = true;
          console.log('Playlist created successfully:', res);
          this.closePlayListPopup();
        },
        error: (err) => {
          console.error('Error creating playlist:', err);
        }
      });
    } else if (this.formMode === 'edit' && this.editPlaylistId) {
      // Update API
      this.authService.CreateUpdatePlayList(this.editPlaylistId, formData).subscribe({
        next: (res) => {
          this.moveToAssignSongs(this.assignSongsToParticularObj, '');
          this.deployments = true;
          console.log('Playlist updated successfully:', res);
          this.closePlayListPopup();
        },
        error: (err) => {
          console.error('Error updating playlist:', err);
        }
      });
    }
  }
}

  openAddPalylistForm(){
    this.showPopup = true;
    this.formMode = 'add';
    this.formTitle = 'Add Playlist';
    this.playlistForm.reset();
  }

  deletePlaylists(text:any,playlist: any) {
    this.SpinnerService.show();
    if (!playlist?.id) {
      console.error("Playlist ID is missing");
       this.SpinnerService.hide();
      return;
    }
    this.authService.deletePlaylist(playlist.id).subscribe({
      next: (res) => {
        if(text == 'viewallPlaylist'){
         this.conentApproval = false;
         this.moveToViewALLContent(this.viewAllName);
        }else{
         this.moveToAssignSongs(this.assignSongsToParticularObj, '');
         this.deployments = true;
        }
        this.SpinnerService.hide();
        this.tosterService.success('Playlist deleted successfully');
        console.log("Playlist deleted successfully:", res);
      },
      error: (err) => {
        this.SpinnerService.hide();
        this.tosterService.error(err.err)
        console.error("Error deleting playlist:", err);
      }
    });
  }

  deleteSong(text:any,playlist: any) {
    this.SpinnerService.show();
    if (!playlist?.id) {
      console.error("Song ID is missing");
       this.SpinnerService.hide();
      return;
    }
    this.authService.deleteSong({
        globalPlaylistId: this.assignSongsToParticularObj.id,
        songsIds: [
          playlist?.id
        ]
      }).subscribe({
      next: (res) => {
        this.moveToAssignSongs(this.publisherSongs, 'viewSongs');
        this.tosterService.success('Song deleted successfully');
        console.log("Playlist deleted successfully:", res);
        this.SpinnerService.hide();
      },
      error: (err) => {
        console.error("Error deleting playlist:", err);
        this.tosterService.error(err.err)
        this.SpinnerService.hide();
      }
    });
  }

  editform(playlist: any) {
    this.showPopup = true;
    this.formMode = 'edit';
    this.formTitle = 'Edit Playlist';
    this.editPlaylistId = playlist.id;
    this.playlistForm.patchValue({
      playlistName: playlist.playlistName,
      playlistImage: null 
    });
    this.playlistForm.get('playlistImage')?.clearValidators();
    this.playlistForm.get('playlistImage')?.updateValueAndValidity();
  }

  closePlayListPopup() {
    this.showPopup = false;
    this.playlistForm.reset();
    this.imageError = null;
    this.SpinnerService.hide();
  }

  getAllManageNotification(page: number = 0) {
    this.SpinnerService.show();
    this.authService.getAllNotifications(page, this.recordsPerPage).subscribe({
      next: (res: any) => {
        this.SpinnerService.hide();
        this.notificationData = res?.content ?? [];
        this.currentPage = res.page + 1;
        this.totalEntries = res.totalElements;
        this.totalPages = res.totalPages;
        this.generatePages();
      },
      error: (error: any) => {
        console.log(error)
        this.SpinnerService.hide();
      }
    });
  }

  pauseNotification(id: Number) {
    this.SpinnerService.show();
    if (id) {
      this.authService.pauseNotification(id).subscribe({
        next: (res: any) => {
          this.SpinnerService.hide();
          console.log(res)
          this.tosterService.success(res?.message || 'Notification Paused Sucessfully')
          this.getAllManageNotification(this.currentPage-1)
        },
        error: (error: any) => {
          console.log(error)
          this.SpinnerService.hide();
          this.tosterService.error(error.err || 'Something went Wrong while pausing')
        }
      })
    }
  }

  resumeNotification(id: Number) {
    this.SpinnerService.show();
    if (id) {
      this.authService.resumeNotification(id).subscribe({
        next: (res: any) => {
          this.SpinnerService.hide();
          this.tosterService.success(res?.message || 'Notification activated successfully')
          this.getAllManageNotification(this.currentPage-1)
        },
        error: (error: any) => {
          console.log(error)
          this.SpinnerService.hide();
          this.tosterService.error(error.err || 'Something went Wrong while resume')
        }
      })
    }
  }

  deleteNotification(id: Number) {
    this.SpinnerService.show();
    if (id) {
      this.authService.deleteNotification(id).subscribe({
        next: (res: any) => {
          this.SpinnerService.hide();
          console.log(res)
          this.tosterService.success(res?.message || 'Notification Deleted Sucessfully')
          this.getAllManageNotification(this.currentPage-1)
        },
        error: (error: any) => {
          console.log(error)
          this.SpinnerService.hide();
          this.tosterService.error(error.err || 'Something went Wrong while deleting')
        }
      })
    }
  }

  getTagsData() {
    this.authService.getTagData().subscribe({
      next: (res: any) => {
        if (res) {
          this.tagsData = res;
          console.log(this.tagsData);
        }
      },
      error: (error: any) => {
        console.log(error);
      }
    })
  }

  edit(id:Number){
    this.router.navigate(['/add-notification',{id:id}])
  }

  onFilterChange() {
    this.fetchNotifications();
  }

  onSearchChange() {
    this.fetchNotifications();
  }

  openManageNotification(){
    this.currentPage = 1;
    this.pages = [];
    this.totalEntries = 0;
    this.getAllManageNotification(0);
    this.showContentConfiguration = false;
    this.tags = false;
    this.manageNotification = true
    this.containers = false;
    this.deployments = false;
    this.publisher = false;
    this.music = false;
    this.conentApproval = false;
    this.Artist = false;
    this.Generes = false;
    this.role = false;
    this.user = false;
    this.getTagsData()
  }

  fetchNotifications() {
    let params: any = { page: this.page, size: this.size };
    if (this.selectedType) {
      params.type = this.selectedType;
    }
    if (this.selectedAudience) {
      params.targetAudience = this.selectedAudience;
    }

    if (this.searchsTerm && this.searchsTerm.trim() !== '') {
      params.search = this.searchsTerm.trim();
    }

    this.authService.getNotifications(params).subscribe({
      next: (res: any) => {
        console.log(res);
        this.notificationData = res?.content ?? [];
        this.currentPage = res.page + 1;
        this.totalEntries = res.totalElements;
        this.totalPages = res.totalPages;
        this.generatePages();
      },
      error: (err) => {
        console.error(err)
      }
    });
  }

  focusInput(){
    this.searchInput.nativeElement.focus()
  }

}